/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * apiClient
 * OpenAPI spec version: 1.0
 */
import { customInstance } from './mutator/custom-instance';
import type { BodyType } from './mutator/custom-instance';
/**
 * Errors
 */
export type ErrorErrors = {[key: string]: unknown};

export interface Error {
  /** Errors */
  errors?: ErrorErrors;
  /** Error name */
  status?: string;
  /** Error code */
  code?: number;
  /** Error message */
  message?: string;
}

export interface PaginationMetadata {
  total?: number;
  total_pages?: number;
  first_page?: number;
  last_page?: number;
  page?: number;
  previous_page?: number;
  next_page?: number;
}

export interface Municipality {
  oficialniWebUrl: string;
  nazev: string;
}

export interface Subject {
  id: number;
  zkrNazev: string;
  barva: string;
  /** @nullable */
  plnyNazev?: string | null;
}

export interface Leader {
  /** @nullable */
  do?: string | null;
  idZastupitel: number;
  /** @nullable */
  od?: string | null;
  funkce: string;
}

export interface Discussion {
  predmetHlasovani: string;
}

export interface MemberVote {
  prezencne: boolean;
  idZastupitel: number;
  hlas: string;
}

export interface Vote {
  platne: boolean;
  cislo: string;
  projednavano?: Discussion[];
  /** @nullable */
  urlProtokol?: string | null;
  prijato: boolean;
  cas: string;
  zastupiteleHlasy?: MemberVote[];
  id: number;
  proceduralni: boolean;
}

export type SessionUrl = {[key: string]: unknown};

export interface Session {
  url?: SessionUrl;
  cislo: string;
  hlasovani: Vote[];
  datum_do: string;
  id: number;
  datum_od: string;
}

export interface Coalition {
  /** @nullable */
  do: string | null;
  idPolitickeSubjekty: number[];
  /** @nullable */
  od: string | null;
}

export interface Council {
  lidr?: Leader[];
  zasedani?: Session[];
  /** @nullable */
  od: number | null;
  /** @nullable */
  do: number | null;
  koalice?: Coalition[];
  poradiZastupitelstva: number;
}

export interface Alias {
  /** First name */
  jmeno: string;
  /**
   * End date of the alias
   * @nullable
   */
  datum_do: string | null;
  /** Alias ID */
  id: number;
  /** Last name */
  prijmeni: string;
  /** Start date of the alias */
  datum_od: string;
}

export interface MemberParty {
  idPolitickySubjekt: number;
  /** @nullable */
  do: string | null;
  /** @nullable */
  od: string | null;
  poradiZastupitelstva: number;
}

export interface Member {
  jmeno: string;
  readonly photo?: string;
  aliasy?: Alias[];
  politickeSubjekty?: MemberParty[];
  pohlavi: boolean;
  id: number;
  prijmeni: string;
}

export interface Dataset {
  municipalita: Municipality;
  politickeSubjekty?: Subject[];
  zastupitelstva?: Council[];
  zastupitele?: Member[];
}

export interface SearchVote {
  /** Vote ID */
  id: number;
  /** Subject of the vote */
  predmet: string;
}

export interface SearchParty {
  /** Party ID */
  party_id: number;
  /** Party name or abbreviation */
  party_name: string;
}

export interface SearchMember {
  /** Member ID */
  id: number;
  /** Member first name */
  jmeno: string;
  /** Member last name */
  prijmeni: string;
}

export interface SearchResult {
  /** List of voting results matching the search */
  votings: SearchVote[];
  /** List of parties matching the search */
  parties: SearchParty[];
  /** List of members matching the search */
  members: SearchMember[];
}

export interface ResponsesLeader {
  /** Leader first name */
  firstName: string;
  /**
   * End date of leadership (nullable)
   * @nullable
   */
  date_to?: string | null;
  /** Leader sex (0=male 1=female) */
  gender: number;
  /** Leader last name */
  lastName: string;
  /** Shortcut of the political party */
  partyName: string;
  /** Leader function */
  function: string;
  /** Color of the political party in HEX */
  partyColor: string;
  /** Leader ID */
  id: number;
  /** Start date of leadership (nullable) */
  date_from: string;
}

export interface Mandate {
  /** Party color in HEX */
  strana_barva: string;
  /** Party abbreviation */
  strana_zkratka: string;
  /** Party ID */
  strana_id: number;
  /** Number of mandates */
  pocet_mandatu: number;
}

export interface LatestSession {
  /** Number of attendees */
  ucast: number;
  /** Session number */
  cislo: string;
  /** Attendance percentage */
  attendance: number;
  /** List of mandates (subject) */
  mandaty: Mandate[];
  /** Number of male representatives */
  zastupitele: number;
  /** Total */
  celkem: number;
  /** List of legal mandates (party) */
  legalni_mandaty: Mandate[];
  /** Number of female representatives */
  zastupitelky: number;
  /** Session ID */
  id: number;
  /** Number of members */
  clenu: number;
  /** Date */
  datum: string;
}

export interface CoalitionParty {
  /** Party abbreviation */
  strana_zkratka: string;
}

export interface GeneralData {
  /** Number of currently active female representatives */
  pocet_zastupitelek: number;
  /** Total number of female representatives who have ever served this term */
  pocet_zastupitelek_celkem: number;
  /** Total number of male representatives who have ever served this term */
  pocet_zastupitelu_celkem: number;
  /** List of council leaders */
  leaders: ResponsesLeader[];
  /** Total number of sessions */
  pocet_zasedani: number;
  /** Latest session data */
  nejnovejsi_zasedani: LatestSession;
  /** Council number */
  cislo_zastupitelstva: number;
  /** Total number of votes by members */
  pocet_hlasovani_clenu: number;
  /** Council leader name */
  leader: string;
  /** Total number of votes */
  pocet_hlasovani: number;
  /** Coalition parties */
  koalice: CoalitionParty[];
  /** Number of currently active male representatives */
  pocet_zastupitelu: number;
  /** Total number of parties */
  celkem_stran: number;
  /** Leader function */
  leader_funkce: string;
  /** Functional period */
  funkcni_obdobi: string;
  /** Leader gender (0=male,1=female) */
  leader_pohlavi: number;
}

export interface Meeting {
  /** Meeting ID */
  id: number;
  /** Meeting number label */
  meeting_number: string;
}

export interface SessionsByCodeItem {
  /** Attendance option ID */
  id: number;
  /** List of meetings for the attendance option */
  sessions: Meeting[];
  /** Attendance option code */
  code: string;
}

export interface CountByCodeItem {
  /** Option ID */
  id: number;
  /** Count for the option */
  count: number;
  /** Option code */
  code: string;
}

export interface VotesPerParty {
  /** Attendance percentage for the party */
  attendance_stat: number;
  /** Sorted list of vote option summary items for the party */
  vote_options: CountByCodeItem[];
  /** Sorted list of meetings grouped by attendance code for the party */
  sessions_by_attendance: SessionsByCodeItem[];
  /** Number of votes when present */
  votes_present: number;
  /** Sorted list of attendance summary items for the party */
  attendance_sum: CountByCodeItem[];
  /** Party ID */
  party_id: number;
  /** Total number of votes */
  votes_total: number;
}

export interface MemberPosition {
  /**
   * End date of the position
   * @nullable
   */
  date_to?: string | null;
  /** Position title */
  position: string;
  /** Start date of the position */
  date_from: string;
  /** Whether the member is a leader in this position (1/0) */
  leader: number;
}

/**
 * Dynamic dictionary of integer counts keyed by code
 */
export type HlasovaniUcast = {[key: string]: number};

export interface Hlasovani {
  /** Sorted list of voting summary items */
  sumarizace: CountByCodeItem[];
  /** Dynamic dictionary of integer counts keyed by code */
  ucast?: HlasovaniUcast;
  total: number;
  aktivni_platna: number;
}

export interface PolitickaStrana {
  /** @nullable */
  datum_do?: string | null;
  strana_barva: string;
  zkratka: string;
  pocet_zasedani_v_ramci_strany: number;
  id: number;
  /** @nullable */
  datum_od?: string | null;
}

export interface CouncilMemberAtte {
  /** Sorted list of attendance summary items */
  sumarizace: CountByCodeItem[];
  /** Attendance percentage */
  attendance_stat: number;
  /** Total meetings */
  celkem_zasedani: number;
  /** Mandate count */
  mandat: number;
}

export interface CouncilMember {
  /** Sorted list of meetings grouped by attendance code */
  zasedani: SessionsByCodeItem[];
  jmeno: string;
  votes_per_party: VotesPerParty[];
  /** Url of the member photo */
  readonly photo?: string;
  /** List of aliases used by the member */
  aliasy?: Alias[];
  /** List of positions held by the member */
  positions: MemberPosition[];
  hlasovani: Hlasovani;
  registrovane_politicke_strany?: PolitickaStrana[];
  /** Elected for the state */
  stat?: string;
  pohlavi: number;
  /** @nullable */
  birth_date?: string | null;
  dochazka: CouncilMemberAtte;
  aktivni_clen: number;
  id: number;
  politicke_strany: PolitickaStrana[];
}

export interface ComparisonMetric {
  /** Number of council members the comparison is computed over */
  pocet_clenu: number;
  /**
   * Average value across the member's own current party, null when not applicable to this metric
   * @nullable
   */
  prumer_klubu?: number | null;
  /**
   * Share of council members with a strictly lower value (0-100), null when the council is too small to be meaningful
   * @nullable
   */
  percentil?: number | null;
  /** Average value across every member of the council */
  prumer_snemu: number;
  /** This member's own value for the metric (0-100) */
  hodnota: number;
}

export interface MemberComparison {
  /** Voting participation rate vs. party and council averages */
  ucast_v_hlasovani: ComparisonMetric;
  /** Agreement rate with the member's own party's majority position vs. council average */
  shoda_s_klubem: ComparisonMetric;
}

export interface AppInfo {
  /** Application description */
  popis: string;
  /** Application abbreviation */
  zkratka: string;
  /** Application name */
  nazev: string;
}

export interface Organ {
  /** Number of representatives */
  pocet_zastupitelu: number;
  /**
   * Meeting place
   * @nullable
   */
  misto?: string | null;
  /** Municipality organ ID */
  id: number;
}

export interface Organy {
  /** Council details */
  rada: Organ;
  /** Assembly details */
  zastupitelstvo: Organ;
  /** Parliament details */
  snemovna: Organ;
}

export interface Municipalities {
  /** Type code of city (e.g. statutarni_mesto) */
  typ_code: string;
  /** City website URL */
  url: string;
  /** City color HEX */
  barva: string;
  /** Timezone */
  casova_zona: string;
  /** Whether city is a project partner */
  partner: boolean;
  /** Logo filename or URL */
  logo: string;
  /** Contact email */
  email: string;
  /** City ID */
  id: number;
  /** Text ID slug */
  text_id: string;
  /** City bodies/assemblies data */
  organy: Organy;
}

export interface MunicipalityExtended {
  /** Type code of city (e.g. statutarni_mesto) */
  typ_code: string;
  /** City website URL */
  url: string;
  /** City color HEX */
  barva: string;
  /** Timezone */
  casova_zona: string;
  /** Whether city is a project partner */
  partner: boolean;
  /** Logo filename or URL */
  logo: string;
  /** Contact email */
  email: string;
  /** City ID */
  id: number;
  /** Text ID slug */
  text_id: string;
  /** City bodies/assemblies data */
  organy: Organy;
  /** Additional typ_id field specific to extended schema */
  typ_id: number;
}

export interface Councils {
  /**
   * End year of the council period
   * @nullable
   */
  funkcni_obdobi_do: number | null;
  /** Order of the council */
  poradi: number;
  /**
   * Start year of the council period
   * @nullable
   */
  funkcni_obdobi_od: number | null;
}

export interface SessionData {
  /** Number of accepted valid votes */
  pocet_prijatych_hlasovani: number;
  /** Number of attending members */
  ucast: number;
  /** Number of close valid votes (margin below threshold) */
  pocet_tesnych_hlasovani: number;
  /** Session end date */
  datum_do: string;
  /** Number of rejected valid votes */
  pocet_zamitnutych_hlasovani: number;
  /** Total number of members */
  celkem: number;
  /** Attendance percentage */
  dochazka: number;
  /** Session ID */
  id: number;
  /** Number of valid votes */
  pocet_platnych_hlasovani: number;
  /** Session number */
  cislo_zasedani: string;
  /** Session start date */
  datum_od: string;
}

export interface VoteCount {
  /** Number of valid votes */
  platna: number;
  /** Number of rejected votes */
  neprijata: number;
  /** Number of accepted votes */
  prijata: number;
  /** Number of invalid votes */
  neplatna: number;
}

export interface VideoRecord {
  /** List of video recording URLs */
  url: string[];
}

export interface ResponsesSession {
  /** Number of attending members */
  ucast: number;
  /** Attendance percentage */
  attendance: number;
  /** End date of the session */
  datum_do: string;
  /** Total number of members */
  celkem: number;
  /** Vote counts for the session */
  pocet_hlasovani: VoteCount;
  /** List of video recordings */
  video_zaznam: VideoRecord[];
  /** Session ID */
  id: number;
  /** Session number */
  cislo_zasedani: string;
  /** Start date of the session */
  datum_od: string;
}

export interface AttendanceSummaryItem {
  /** Attendance option ID */
  id: number;
  /** Attendance count */
  count: number;
  /** Attendance option code */
  code: string;
}

export interface ResponsesMember {
  /** Gender of member (0=male, 1=female) */
  clen_pohlavi: number;
  /** Member ID */
  clen_id: number;
  /** List of aliases used by the member */
  aliasy?: Alias[];
  /** Member last name */
  clen_prijmeni: string;
  /** Member first name */
  clen_jmeno: string;
  /** Url of the member photo */
  readonly clen_photo?: string;
}

export interface PartyDetail {
  /** Party color in HEX */
  strana_barva: string;
  /** Party abbreviation */
  strana_zkratka: string;
  /** Party ID */
  strana_id: number;
  /** List of members */
  clenove: ResponsesMember[];
}

export interface AttendanceDetailItem {
  /** Parties and members for the attendance option */
  strany: PartyDetail[];
  /** Attendance option ID */
  id: number;
  /** Attendance option code */
  code: string;
}

export interface SessionAttendance {
  /** Sorted list of attendance summary items */
  sumarizace: AttendanceSummaryItem[];
  /** Sorted list of attendance detail items */
  detail: AttendanceDetailItem[];
  /** Session number */
  cislo_zasedani: string;
}

export interface VoteSummaryItem {
  /** Vote option ID */
  id: number;
  /** Vote count */
  count: number;
  /** Vote option code */
  code: string;
}

export interface VoteMember {
  /** First name */
  jmeno: string;
  /** Url of the member photo */
  readonly photo?: string;
  /** Aliases used during the vote */
  aliasy?: Alias[];
  /** Gender */
  pohlavi: number;
  /** Member ID */
  id: number;
  /** Last name */
  prijmeni: string;
}

export interface PartyVote {
  /** List of people who voted this way */
  lide: VoteMember[];
  /** Party ID */
  strana_id: number;
  /** Party color (hex code) */
  strana_barva: string;
  /** Party abbreviation */
  strana_zkratka: string;
  /** Number of votes for this party and option */
  pocet: number;
}

export interface VoteSummaryByPartyItem {
  /** Parties and members for the vote option */
  strany: PartyVote[];
  /** Vote option ID */
  id: number;
  /** Vote option code */
  code: string;
}

export interface VoteDetail {
  /** True when vote result is 'ACCEPTED' */
  vysledek: boolean;
  /** Vote number */
  cislo_hlasovani: string;
  /** Is the vote secret? (1 or 0) */
  tajne_hlasovani: number;
  /** Subject of the vote */
  predmet_hlasovani: string;
  /** Sorted list of vote summary items */
  sumarizace: VoteSummaryItem[];
  /** Is the vote procedural (1 or 0) */
  proceduralni_hlasovani: number;
  /**
   * URL to protocol file
   * @nullable
   */
  soubor?: string | null;
  /** Sorted list of vote summary items by party */
  sumarizace_po_stranach: VoteSummaryByPartyItem[];
  /** Is the vote ammended (1 or 0) */
  pozmenovaci_hlasovani?: number;
  /** Total members present */
  pritomno: number;
  /** Whether the vote is valid (1 or 0) */
  validni_hlasovani: number;
  /** Datetime of the vote */
  datum_cas: string;
  /** Meeting number */
  cislo_zasedani: string;
}

export interface VoteBasicData {
  /** Total number of sessions */
  pocet_zasedani: number;
  /** Total number of accepted votes */
  pocet_prijatych: number;
  /** Total number of invalid votes */
  pocet_neplatnych: number;
  /** Total number of rejected votes */
  pocet_neprijatych: number;
  /** Total number of votes */
  pocet_hlasovani: number;
  /** Total number of non-procedural votes */
  pocet_neproceduralnich: number;
}

export interface VotesQuery {
  /** Vote ID to filter by */
  id_hlasovani: number;
  /** True if vote result is 'ACCEPTED' */
  vysledek: boolean;
  /** Vote number to filter by */
  cislo_hlasovani: string;
  /** Number of secret votes */
  tajne?: number;
  /** Number of NO votes */
  ne?: number;
  /** Number of YES votes */
  ano?: number;
  /** Number of ABSTAIN votes */
  zdrzel_se?: number;
  /** Number of valid votes */
  validni?: number;
  /** Subject of the vote to filter by */
  predmet_hlasovani: string;
  /** result of vote match in percentage */
  vote_match?: string;
  /** Session number to filter by */
  cislo_zasedani?: string;
  /** Number of procedural votes */
  proceduralni?: number;
}

export interface OtherParty {
  /** Party color in HEX */
  party_color: string;
  /** Party abbreviation */
  shortcut: string;
}

export interface PartyMember {
  /** Structure of another party that the member belongs to */
  political_party?: OtherParty;
  /** Full name */
  jmeno: string;
  /** Url of the member photo */
  readonly photo?: string;
  /** List of aliases used by the member */
  aliasy?: Alias[];
  /** Physical meeting attendance percentage (Dochazka), distinct from voting participation */
  fyzicka_ucast?: number;
  /** Number of meetings the member was physically present at (Dochazka) */
  zasedani_pritomen?: number;
  /** Number of meetings with attendance records during the member's mandate in this party */
  zasedani_celkem?: number;
  /** Elected for the state */
  stat?: string;
  /** Gender (0=male,1=female) */
  pohlavi: number;
  /** Leadership positions held while a member of this party */
  vedeni?: MemberPosition[];
  /** Active status (1=active, 0=inactive) */
  aktivni: number;
  /** Member ID */
  id: number;
  /** Active member status (1=active, 0=inactive) */
  active_member?: number;
}

export interface PartiesData {
  /** List of members */
  clenove: PartyMember[];
  /** Party ID */
  strana_id: number;
  /** Party color in HEX */
  strana_barva: string;
  /** Number of active members */
  pocet_aktivnich: number;
  /** Number of inactive members */
  pocet_neaktivnich: number;
  /** Party abbreviation */
  strana_zkratka: string;
}

export interface PartyStats {
  /** Sorted list of party vote summary items */
  celkove_hlasy: VoteSummaryItem[];
  /** Overall attendance percentage or count */
  celkova_ucast: number;
  /** Party ID */
  strana_id: number;
  /** Party color in HEX */
  strana_barva: string;
  /** Party abbreviation */
  strana_zkratka: string;
}

export interface CoalitionPeriod {
  /**
   * End date of this coalition membership period (null = still in coalition)
   * @nullable
   */
  datum_do?: string | null;
  /**
   * Start date of this coalition membership period
   * @nullable
   */
  datum_od?: string | null;
}

export interface CohesionSessionItem {
  /** Session number */
  zasedani: string;
  /**
   * Unity index for this session (null if no valid votes)
   * @nullable
   */
  hodnota?: number | null;
}

export interface Cohesion {
  /** Trend direction: up, down, or stable */
  smer: string;
  /**
   * Session number of the term's least-united vote
   * @nullable
   */
  min_cohesion_vote_zasedani?: string | null;
  /**
   * Average unity index across the term
   * @nullable
   */
  prumer?: number | null;
  /**
   * Subject/description of the term's least-united vote
   * @nullable
   */
  min_cohesion_vote_predmet?: string | null;
  /**
   * ID of the term's least-united vote, for linking to its detail page (null if the party has no valid votes)
   * @nullable
   */
  min_cohesion_vote_id?: number | null;
  /**
   * Unity index of the term's least-united vote
   * @nullable
   */
  min_cohesion_vote_hodnota?: number | null;
  /**
   * Vote number (within its session) of the term's least-united vote
   * @nullable
   */
  min_cohesion_vote_cislo?: string | null;
  /** Unity index per session, chronologically ordered */
  vyvoj: CohesionSessionItem[];
}

export interface Dochazka {
  /** Total number of meetings */
  celkem_zasedani: number;
  /** Mandate count (e.g. seats held or max meetings) */
  mandat: number;
}

export interface SeatsOverTimeItem {
  /** Session number */
  zasedani: string;
  /** Number of seats the party held at this session */
  pocet_mandatu: number;
}

export interface PartyData {
  /** List of party members */
  clenove: PartyMember[];
  /** Sorted list of party vote summary items */
  celkove_hlasy: VoteSummaryItem[];
  /** Dated history of coalition membership periods */
  koalice_historie: CoalitionPeriod[];
  /** Party-wide physical meeting attendance percentage (Dochazka), distinct from voting participation */
  fyzicka_ucast: number;
  /** Overall attendance percentage */
  attendance: number;
  /** Voting cohesion (unity index) for this party */
  cohesion: Cohesion;
  /** Party ID */
  strana_id: number;
  /** Total participation count */
  celkovy_pocet_ucast: number;
  /** Whether party is coalition party (1/0) */
  koalicni_strana: number;
  /** Number of active members */
  pocet_aktivnich: number;
  /** Total number of votes */
  celkovy_pocet_hlasovani: number;
  /** Number of inactive members */
  pocet_neaktivnich: number;
  /** Party color in HEX */
  strana_barva: string;
  /** Meeting attendance data */
  dochazka: Dochazka;
  /**
   * Party full name (nullable)
   * @nullable
   */
  strana_nazev?: string | null;
  /** Party abbreviation */
  strana_zkratka: string;
  /** Seat count per session, chronologically ordered */
  mandaty_vyvoj: SeatsOverTimeItem[];
}

export interface PartyAgreementItem {
  /** Agreement percentage with this other party */
  shoda: number;
  /** Other party's ID */
  strana_id: number;
  /** Other party's color in HEX */
  strana_barva: string;
  /** Number of votes both parties took a YES/NO/ABSTAIN position on */
  pocet_spolecnych_hlasovani: number;
  /** Other party's abbreviation */
  strana_zkratka: string;
}

export interface DropdownOptions {
  /** Name of the option */
  name: string;
  /** Code or ID of the option */
  id: number;
}

export interface DropdownOptionsCode {
  /** Option ID */
  id: number;
  /** Code of the option */
  code: string;
}

export interface DropdownYearOptions {
  /** Option year as an integer */
  name: number;
  /** Code or ID of the option */
  id: number;
}

export interface ResponsesDataset {
  /** Percentage unity data per session */
  data: (number | null)[];
  /** Party label */
  label: string;
  /** Border color(s) for the chart */
  borderColor: string[];
  /** Background color(s) for the chart */
  backgroundColor: string[];
}

export interface PartiesUnity {
  /** Unity data for each party */
  datasets: ResponsesDataset[];
  /** Session labels */
  labels: string[];
}

export interface MemberAttendance {
  /** First name */
  jmeno: string;
  /** Url of the member photo */
  readonly photo?: string;
  /** List of aliases */
  aliasy?: Alias[];
  /** Total meetings */
  sum: number;
  /** Number of present meetings */
  act_sum: number;
  /** 1 if member is in party during term */
  in_party: number;
  /** Gender (0=male, 1=female) */
  pohlavi: number;
  /** Attendance percentage */
  dochazka: number;
  /** Last name */
  prijmeni: string;
  /** Member ID */
  id: number;
  /** Whether the member is active */
  aktivni: number;
}

export interface PartyAttendance {
  /** List of members in party */
  clenove: MemberAttendance[];
  /** Whether the party had active members in term */
  is_active: number;
  /** Party ID */
  strana_id: number;
  /** Party color */
  strana_barva: string;
  /** Party abbreviation */
  strana_zkratka: string;
}

export interface AttendanceOverview {
  /** Attendance data per party */
  data: PartyAttendance[];
  /** Total number of active members */
  pocet_clenu: number;
}

export interface CompareSession {
  name: string;
  code: number;
}

export interface SessionVoteDetail {
  id_hlasovani: number;
  /** True when 'ACCEPTED' */
  vysledek: boolean;
  cislo_hlasovani: string;
  /** Either 'ano' or 'ne' */
  shoda: string;
  predmet_hlasovani: string;
  cislo_zasedani: string;
}

export interface SessionResult {
  shoda: SessionVoteDetail[];
  neshoda: SessionVoteDetail[];
}

export type CompareResponseData = {[key: string]: SessionResult};

export interface CompareResponse {
  zasedani: CompareSession[];
  match_stat: number;
  /**
   * End date in format dd.MM.yyyy
   * @nullable
   */
  date_to?: string | null;
  shoda: number;
  neshoda: number;
  data: CompareResponseData;
  /**
   * Start date in format dd.MM.yyyy
   * @nullable
   */
  date_from?: string | null;
}

export interface RegionsResponse {
  /** List of scopes */
  data: string[];
}

export interface GeoItem {
  id: string;
}

export interface GeoResponse {
  /** List of {id} for desired scope */
  data: GeoItem[];
}

export interface MetricItem {
  id: string;
}

export interface MetricsResponse {
  /** List of available metrics for desired area */
  data: MetricItem[];
}

export interface Range {
  min: number;
  max: number;
}

export type SourceDetailDims = {[key: string]: string[]};

export interface SourceDetail {
  range: Range;
  dims: SourceDetailDims;
  /** @nullable */
  url?: string | null;
  chart_types: string[];
}

export type FiltersResponseDetails = {[key: string]: SourceDetail};

export interface FiltersResponse {
  sources: string[];
  details: FiltersResponseDetails;
  default: string;
}

export interface InsightsComparison {
  mean_primary: number;
  primary: string;
  compare: string;
  mean_compare: number;
  diff: number;
}

export type InsightsLatestDirection = typeof InsightsLatestDirection[keyof typeof InsightsLatestDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightsLatestDirection = {
  up: 'up',
  down: 'down',
} as const;

export interface InsightsLatest {
  direction: InsightsLatestDirection;
  latest_val: number;
  latest_year: number;
  prev_val: number;
  diff: number;
  prev_year: number;
}

export interface InsightsTrend {
  start_val: number;
  start_year: number;
  end_year: number;
  end_val: number;
}

export interface InsightsExtremes {
  min_year: number;
  min_val: number;
  max_val: number;
  max_year: number;
}

export type InsightsBiggestChangeDirection = typeof InsightsBiggestChangeDirection[keyof typeof InsightsBiggestChangeDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightsBiggestChangeDirection = {
  up: 'up',
  down: 'down',
} as const;

export interface InsightsBiggestChange {
  change_year: number;
  cur_val: number;
  direction: InsightsBiggestChangeDirection;
  prev_val: number;
  diff: number;
  prev_year: number;
}

/**
 * @nullable
 */
export type InsightsGeoLatestAnyOf = { [key: string]: unknown } | null;

export type InsightsGeoLatest = InsightsGeoLatestAnyOf | InsightsLatest;

/**
 * @nullable
 */
export type InsightsGeoTrendAnyOf = { [key: string]: unknown } | null;

export type InsightsGeoTrend = InsightsGeoTrendAnyOf | InsightsTrend;

/**
 * @nullable
 */
export type InsightsGeoExtremesAnyOf = { [key: string]: unknown } | null;

export type InsightsGeoExtremes = InsightsGeoExtremesAnyOf | InsightsExtremes;

/**
 * @nullable
 */
export type InsightsGeoBiggestChangeAnyOf = { [key: string]: unknown } | null;

export type InsightsGeoBiggestChange = InsightsGeoBiggestChangeAnyOf | InsightsBiggestChange;

export interface InsightsGeo {
  latest: InsightsGeoLatest;
  trend: InsightsGeoTrend;
  extremes: InsightsGeoExtremes;
  biggest_change: InsightsGeoBiggestChange;
  /** @nullable */
  average: number | null;
}

export type InsightsCorrelationStrength = typeof InsightsCorrelationStrength[keyof typeof InsightsCorrelationStrength];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightsCorrelationStrength = {
  strong_positive: 'strong_positive',
  moderate_positive: 'moderate_positive',
  moderate_negative: 'moderate_negative',
  strong_negative: 'strong_negative',
} as const;

export interface InsightsCorrelation {
  r: number;
  geo_a: string;
  geo_b: string;
  strength: InsightsCorrelationStrength;
}

export type InsightsPerGeo = {[key: string]: InsightsGeo};

export interface Insights {
  comparisons: InsightsComparison[];
  per_geo: InsightsPerGeo;
  correlations: InsightsCorrelation[];
}

export type DataResponseData = {[key: string]: {[key: string]: number}};

/**
 * @nullable
 */
export type DataResponseInsightsAnyOf = { [key: string]: unknown } | null;

export type DataResponseInsights = DataResponseInsightsAnyOf | Insights;

export interface DataResponse {
  data: DataResponseData;
  insights?: DataResponseInsights;
  compare_geo: string[];
}

export interface BiggestChange {
  year: string;
  old_value: number;
  revision_date: string;
  new_value: number;
  abs_diff: number;
}

/**
 * @nullable
 */
export type RevisionsResponseBiggestChangeAnyOf = { [key: string]: unknown } | null;

export type RevisionsResponseBiggestChange = RevisionsResponseBiggestChangeAnyOf | BiggestChange;

export interface RevisionsResponse {
  /** @nullable */
  first_recorded: string | null;
  added_points: number;
  modified_points: number;
  version_count: number;
  biggest_change: RevisionsResponseBiggestChange;
  modification_events: number;
  extension_events: number;
}

export interface Language {
  en_name: string;
  active?: boolean;
  language_code: string;
  local_name: string;
}

export interface DropdownLanguage {
  /** Language label */
  name: string;
  /** Language code */
  language_code: string;
}

export interface VoteOptionLabelItem {
  /** Localized label */
  label: string;
  /**
   * Localized feminine label
   * @nullable
   */
  label_female?: string | null;
  /**
   * Localized universal label
   * @nullable
   */
  label_universal?: string | null;
}

/**
 * Mapping of option key to localized labels
 */
export type VoteOptionLabelMapItemLabels = {[key: string]: VoteOptionLabelItem};

export interface VoteOptionLabelMapItem {
  /** Mapping of option key to localized labels */
  labels: VoteOptionLabelMapItemLabels;
}

/**
 * Mapping of option ID to localized label
 */
export type OptionLabelMapLabels = {[key: string]: string};

export interface OptionLabelMap {
  /** Mapping of option ID to localized label */
  labels: OptionLabelMapLabels;
}

export interface OptionLabelList {
  label: string;
  option_id: number;
}

export interface OptionLabelItem {
  /**
   * Localized genitive label
   * @nullable
   */
  label_genitiv?: string | null;
  /** Localized label */
  label: string;
}

/**
 * Mapping of option key to localized labels
 */
export type OptionLabelMapItemLabels = {[key: string]: OptionLabelItem};

export interface OptionLabelMapItem {
  /** Mapping of option key to localized labels */
  labels: OptionLabelMapItemLabels;
}

export interface OrganOptionLabelItem {
  /**
   * Localized genitive label
   * @nullable
   */
  label_genitiv?: string | null;
  /** Localized label */
  label: string;
  /**
   * Localized application label
   * @nullable
   */
  label_aplikace?: string | null;
  /**
   * Localized application description
   * @nullable
   */
  label_popis_aplikace?: string | null;
}

/**
 * Mapping of option key to localized labels
 */
export type OrganOptionLabelMapItemLabels = {[key: string]: OrganOptionLabelItem};

export interface OrganOptionLabelMapItem {
  /** Mapping of option key to localized labels */
  labels: OrganOptionLabelMapItemLabels;
}

export interface GeoLabelsItem {
  label: string;
  label_ins: string;
  label_gen: string;
  label_lok_prep: string;
  label_aku: string;
  label_lok: string;
}

export type GeoLabelResponseLabels = {[key: string]: GeoLabelsItem};

export interface GeoLabelResponse {
  labels: GeoLabelResponseLabels;
}

export interface UnitLabel {
  label?: string;
  unit?: string;
}

export interface MetricLabel {
  name?: string;
  description?: string;
}

export interface SourceLabel {
  name: string;
  license_url: string;
  license_name: string;
}

export type MetricLabelsDocUnits = {[key: string]: UnitLabel};

export type MetricLabelsDocMetrics = {[key: string]: MetricLabel};

export type MetricLabelsDocSource = {[key: string]: SourceLabel};

export type MetricLabelsDocDimValues = {[key: string]: string};

export type MetricLabelsDocScope = {[key: string]: string};

export type MetricLabelsDocDims = {[key: string]: string};

export interface MetricLabelsDoc {
  units: MetricLabelsDocUnits;
  metrics: MetricLabelsDocMetrics;
  source: MetricLabelsDocSource;
  dim_values: MetricLabelsDocDimValues;
  scope: MetricLabelsDocScope;
  dims: MetricLabelsDocDims;
}

export interface StatsLabelsResponse {
  labels: MetricLabelsDoc;
}

export interface AuthHelloResponse {
  /** Message containing logged user's username */
  message: string;
}

export interface LoginRequest {
  password: string;
  login: string;
}

export interface TokenResponse {
  /** Auth token */
  token: string;
  /** Refresh token */
  refresh: string;
}

export interface RegisterRequest {
  /** @minLength 8 */
  password: string;
  /**
   * @maxLength 50
   * @nullable
   */
  last_name?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  first_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 30
   */
  login: string;
}

export interface UserResponse {
  /**
   * User's last name
   * @nullable
   */
  last_name: string | null;
  /**
   * User's first name
   * @nullable
   */
  first_name: string | null;
  /** User's login */
  login: string;
  /** User's ID */
  id: number;
  /** ID of user's role */
  role: number;
}

export interface Permissions {
  /** Municipality text IDs user can manage */
  manage_municipality: string[];
}

export interface UserPermissionsResponse {
  /** Assigned permissions */
  permissions: Permissions;
  /** User's login */
  login: string;
  /** ID of user's role */
  role: number;
}

export interface ProfileNameEditRequest {
  /**
   * @maxLength 50
   * @nullable
   */
  last_name?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  first_name?: string | null;
}

export interface ProfileChangePasswordRequest {
  /** @minLength 8 */
  new_password: string;
  old_password: string;
}

export interface RequestMunicipality {
  /** Name of the municipality */
  name: string;
  /** Text ID of the municipality */
  text_id: string;
}

export interface RequestUser {
  /**
   * User's last name
   * @nullable
   */
  last_name: string | null;
  /** ID of the user who submitted the request */
  id: number;
  /** User's login */
  login: string;
  /**
   * User's first name
   * @nullable
   */
  first_name: string | null;
}

export interface RequestManageMunicipalityListResponse {
  /** Municipality related to the request */
  municipality: RequestMunicipality;
  /** User who made the request (included for admins only) */
  user?: RequestUser;
  /** Date of the request */
  date: string;
  /**
   * Text content of the request
   * @nullable
   */
  text: string | null;
  /** Type of request */
  type: unknown;
  /**
   * Approval status of the request
   * @nullable
   */
  approved: boolean | null;
  /** ID of the request */
  id: number;
}

export interface RequestManageMunicipalityRequest {
  municipality_text_id: string;
  /**
   * @maxLength 1000
   * @nullable
   */
  text?: string | null;
}

export interface IdResponse {
  /** ID of the affected entity */
  id: number;
}

export interface RequestManageMunicipalityResolveRequest {
  approved: boolean;
}

export interface RequestAddMunicipalityListResponse {
  /** Municipality related to the request */
  municipality: RequestMunicipality;
  /** User who made the request (included for admins only) */
  user?: RequestUser;
  /** Date of the request */
  date: string;
  /**
   * Text content of the request
   * @nullable
   */
  text: string | null;
  /** Type of request */
  type: unknown;
  /**
   * Approval status of the request
   * @nullable
   */
  approved: boolean | null;
  /** ID of the request */
  id: number;
}

export interface RequestAddMunicipalityRequest {
  body_type: number;
  /** @pattern ^#[A-Fa-f0-9]{6}$ */
  color: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_data_url?: string | null;
  /** @maxLength 150 */
  url: string;
  municipality_type: number;
  /** @maxLength 150 */
  zastupitelstvo_name: string;
  /** @minimum 0 */
  zastupitelstvo_member_count: number;
  /** @maxLength 150 */
  zastupitelstvo_application_name: string;
  /** @maxLength 150 */
  zastupitelstvo_name_genitive: string;
  /**
   * @maxLength 1000
   * @nullable
   */
  text?: string | null;
  /** @maxLength 150 */
  name: string;
  /** @maxLength 150 */
  name_genitive: string;
  /**
   * Email
   * @maxLength 100
   * @nullable
   */
  email?: string | null;
  /**
   * @maxLength 50
   * @pattern ^[a-zA-Z-_]+$
   */
  text_id: string;
  /** @maxLength 200 */
  zastupitelstvo_application_description: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_place?: string | null;
}

export interface DetailedMunicipality {
  /** HEX colour code of municipality */
  color: string;
  /** Municipality type code */
  municipality_type_code: string;
  /** Website URL */
  url: string;
  /** Body type code */
  body_type_code: string;
  /** Application name */
  zastupitelstvo_application_name: string;
  /** Name of the political body */
  zastupitelstvo_name: string;
  /** Number of members in the political body */
  zastupitelstvo_member_count: number;
  /** Genitive name of the political body */
  zastupitelstvo_name_genitive: string;
  /** Name of the municipality */
  name: string;
  /** ID of municipality type */
  municipality_type_id: number;
  /** Body type ID */
  body_type_id: number;
  /** Genitive form of municipality name */
  name_genitive: string;
  /**
   * Contact email
   * @nullable
   */
  email: string | null;
  /** Text ID of the municipality */
  text_id: string;
  /** Application description */
  zastupitelstvo_application_description: string;
  /**
   * Location of the political body
   * @nullable
   */
  zastupitelstvo_place: string | null;
}

export interface RequestAddMunicipalityResponse {
  /** Data about the added municipality */
  municipality: DetailedMunicipality;
  /** User who made the request (included for admins only) */
  user?: RequestUser;
  /** Date of the request */
  date: string;
  /**
   * Text content of the request
   * @nullable
   */
  text: string | null;
  /**
   * Approval status of the request
   * @nullable
   */
  approved: boolean | null;
  /** ID of the request */
  id: number;
}

export interface RequestAddMunicipalityResolveRequest {
  approved: boolean;
}

export interface DatabaseResponse {
  /** Deletion status of the database */
  deleted: boolean;
  /** Name of the database's type */
  type_name: string;
  /**
   * Timestamp of the last time the DB was backed up
   * @nullable
   */
  last_backup: string | null;
  /** Name of the database */
  name: string;
  /**
   * Timestamp of the last time the DB was updated
   * @nullable
   */
  last_changed: string | null;
  /** ID of the database */
  id: number;
}

export interface DatabaseAddRequest {
  /** @maxLength 64 */
  name: string;
  db_type: number;
}

export interface DatabaseEditRequest {
  /** @maxLength 64 */
  name: string;
}

export interface DatabaseExportRequest {
  drop_db: boolean;
  drop_table: boolean;
  db_ids: number[];
  include_data: boolean;
  create_db: boolean;
}

export interface DatabaseOneExportRequest {
  include_data: boolean;
  create_db: boolean;
  drop_db: boolean;
  drop_table: boolean;
}

export interface DatabaseImportRequest {
  sql_dump: Blob;
}

export interface BodyList {
  /** Application name */
  application_name: string;
  /**
   * Website URL
   * @nullable
   */
  data_url: string | null;
  /** Name of the body */
  name: string;
  /** Text ID of the municipality */
  municipality_text_id: string;
  /** Number of members */
  member_count: number;
  /** Genitive form of the name of the body */
  name_genitive: string;
  /**
   * Location of the body
   * @nullable
   */
  place: string | null;
  /** Code of the type of the body */
  type_code: string;
  /** ID of the body */
  id: number;
  /** Application description */
  application_description: string;
}

export interface MunicipalityListResponse {
  /** HEX colour code of municipality */
  color: string;
  /** Website URL */
  url: string;
  /** Political bodies under the municipality */
  bodies: BodyList[];
  /** Name of the municipality */
  name: string;
  /** Partnership status of the municipality */
  partner: boolean;
  /** Genitive form of the name of the municipality */
  name_genitive: string;
  /** Filename of the municipality logo */
  logo: string;
  /**
   * Contact email
   * @nullable
   */
  email: string | null;
  /** Code of the type of the municipality */
  type_code: string;
  /** ID of the municipality */
  id: number;
  /** Text ID of the municipality */
  text_id: string;
}

export interface MunicipalityAddRequest {
  body_type: number;
  /** @pattern ^#[A-Fa-f0-9]{6}$ */
  color: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_data_url?: string | null;
  /** @maxLength 150 */
  url: string;
  municipality_type: number;
  track_changes: boolean;
  /** @maxLength 150 */
  zastupitelstvo_name: string;
  /** @minimum 0 */
  zastupitelstvo_member_count: number;
  /** @maxLength 150 */
  zastupitelstvo_application_name: string;
  /** @maxLength 150 */
  zastupitelstvo_name_genitive: string;
  /** @maxLength 150 */
  name: string;
  partner: boolean;
  /** @maxLength 150 */
  name_genitive: string;
  /**
   * Email
   * @maxLength 100
   * @nullable
   */
  email?: string | null;
  /**
   * @maxLength 50
   * @pattern ^[a-zA-Z-_]+$
   */
  text_id: string;
  /** @maxLength 200 */
  zastupitelstvo_application_description: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_place?: string | null;
}

export interface MunicipalityTextIdResponse {
  /** Text ID of the municipality */
  text_id: string;
}

export interface Body {
  /**
   * Website URL
   * @nullable
   */
  url: string | null;
  /** Application name */
  application_name: string;
  /** Name of the body */
  name: string;
  /** Number of members */
  member_count: number;
  /** Genitive form of the name of the body */
  name_genitive: string;
  /**
   * Location of the body
   * @nullable
   */
  place: string | null;
  /** Application description */
  application_description: string;
}

export interface MunicipalityFeature {
  /** Name of the feature */
  name: string;
  /** ID of the feature */
  id: number;
}

/**
 * Political bodies under the municipality
 */
export type MunicipalityResponseBodies = {[key: string]: Body};

export interface MunicipalityResponse {
  /** ID of the municipality type */
  type_id: number;
  /** HEX colour code of municipality */
  color: string;
  /** Time zone of the municipality */
  time_zone: string;
  /** Website URL */
  url: string;
  /** Political bodies under the municipality */
  bodies: MunicipalityResponseBodies;
  /** Political bodies under the municipality */
  features: MunicipalityFeature[];
  /** Name of the municipality */
  name: string;
  /** Partnership status of the municipality */
  partner: boolean;
  /** Genitive form of the name of the municipality */
  name_genitive: string;
  /** Filename of the municipality logo */
  logo: string;
  /**
   * Contact email
   * @nullable
   */
  email: string | null;
  /** Code of the type of the municipality */
  type_code: string;
  /** ID of the municipality */
  id: number;
  /** Text ID of the municipality */
  text_id: string;
}

export interface MunicipalityEditRequest {
  body_type: number;
  /** @pattern ^#[A-Fa-f0-9]{6}$ */
  color: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_data_url?: string | null;
  /** @maxLength 150 */
  url: string;
  municipality_type: number;
  track_changes: boolean;
  /** @maxLength 150 */
  zastupitelstvo_name: string;
  /** @minimum 0 */
  zastupitelstvo_member_count: number;
  /** @maxLength 150 */
  zastupitelstvo_application_name: string;
  /** @maxLength 150 */
  zastupitelstvo_name_genitive: string;
  /** @maxLength 150 */
  name: string;
  /** @nullable */
  partner?: boolean | null;
  /** @maxLength 150 */
  name_genitive: string;
  /**
   * Email
   * @maxLength 100
   * @nullable
   */
  email?: string | null;
  /** @maxLength 200 */
  zastupitelstvo_application_description: string;
  /**
   * @maxLength 150
   * @nullable
   */
  zastupitelstvo_place?: string | null;
}

export interface MunicipalityLogoRequest {
  logo: Blob;
}

export interface BodyAddRequest {
  body_type: number;
  /** @maxLength 200 */
  body_application_description: string;
  /** @maxLength 150 */
  body_application_name: string;
  /** @maxLength 150 */
  body_name: string;
  /** @maxLength 150 */
  body_name_genitive: string;
  /**
   * @maxLength 150
   * @nullable
   */
  body_place?: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  body_data_url?: string | null;
  /** @minimum 0 */
  body_member_count: number;
}

export interface BodyEditRequest {
  /** @maxLength 200 */
  body_application_description: string;
  /** @maxLength 150 */
  body_application_name: string;
  /** @maxLength 150 */
  body_name: string;
  /** @maxLength 150 */
  body_name_genitive: string;
  /**
   * @maxLength 150
   * @nullable
   */
  body_place?: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  body_data_url?: string | null;
  /** @minimum 0 */
  body_member_count: number;
}

export interface PoliticalEntityResponse {
  /**
   * Full name of the entity
   * @nullable
   */
  name: string | null;
  /** Abbrevation of the entity's name */
  abbreviation: string;
  /** ID of the entity */
  id: number;
  /**
   * HEX colour code of the entity
   * @nullable
   */
  color: string | null;
}

export interface PoliticalEntityRequest {
  /**
   * @maxLength 150
   * @nullable
   */
  name?: string | null;
  /** @maxLength 70 */
  abbreviation: string;
  /** @pattern ^#[A-Fa-f0-9]{6}$ */
  color: string;
}

export interface PasswordRequest {
  password: string;
}

export interface MemberAlias {
  /** Alias of a member's last name */
  last_name: string;
  /** Alias of a member's first name */
  first_name: string;
}

export interface MemberResponse {
  /** Member's order in their political entity */
  order: number;
  /** Member's last name */
  last_name: string;
  /** Member's first name */
  first_name: string;
  /**
   * Member's sex
   * @nullable
   */
  sex: boolean | null;
  /** ID of the political entity the member is a part of */
  political_entity_id?: number;
  /** Member's date of birth */
  birth_date?: string;
  /** ID of the member */
  id: number;
  /** Member's aliases */
  aliases?: MemberAlias[];
}

export interface MemberRequest {
  /** @maxLength 50 */
  last_name: string;
  /** @maxLength 50 */
  first_name: string;
  sex: boolean;
  /** @nullable */
  birth_date?: string | null;
}

export interface MemberListMeetingResponse {
  /** List of available members */
  available: MemberResponse[];
  /** List of active members */
  active: MemberResponse[];
}

export interface MemberAliasListResponse {
  /**
   * Date when this alias stopped being valid
   * @nullable
   */
  date_to: string | null;
  /** Alias of a member's last name */
  last_name: string;
  /** Alias of a member's first name */
  first_name: string;
  /** ID of the alias */
  id: number;
  /**
   * Date when this alias came into effect
   * @nullable
   */
  date_from: string | null;
}

export interface AliasAddRequest {
  /** @nullable */
  date_to?: string | null;
  /** @maxLength 50 */
  last_name: string;
  /** @maxLength 50 */
  first_name: string;
  /** @nullable */
  date_from?: string | null;
}

export interface BasePoliticalEntity {
  /**
   * Full name of the entity
   * @nullable
   */
  name: string | null;
  /** Abbrevation of the entity's name */
  abbreviation: string;
  /** ID of the entity */
  id: number;
}

export interface MembershipResponse {
  /**
   * Date when this membership stopped being valid
   * @nullable
   */
  date_to: string | null;
  /** Order of the term this membership belongs to */
  term_order: number;
  /** ID of the membership */
  id: number;
  /**
   * Date when this membership came into effect
   * @nullable
   */
  date_from: string | null;
  /** Political entity this membership is associated with */
  political_entity: BasePoliticalEntity;
}

export interface MemberOrderRequest {
  order: number[];
}

export interface BaseMember {
  /** Member's last name */
  last_name: string;
  /** ID of the member */
  id: number;
  /** Member's first name */
  first_name: string;
}

/**
 * @nullable
 */
export type TermListResponseLeaderAnyOf = { [key: string]: unknown } | null;

/**
 * Information about the leader of the coalition
 */
export type TermListResponseLeader = BaseMember | TermListResponseLeaderAnyOf;

export interface TermListResponse {
  /** Order of the term */
  order: number;
  /** Ending year of the term */
  year_to: number;
  /** Information about the leader of the coalition */
  leader: TermListResponseLeader;
  /** Dataset completness status */
  dataset_complete: boolean;
  /** Starting year of the term */
  year_from: number;
  /** List of political subjects in the coalition */
  coalition: BasePoliticalEntity[];
  /** Name of the leading function */
  leader_title: string;
}

export interface TermMemberData {
  id: number;
  political_entity: number;
}

export interface TermMemberLeadershipData {
  /** @nullable */
  date_to?: string | null;
  leader: boolean;
  id: number;
  /** @nullable */
  date_from?: string | null;
  /** @maxLength 100 */
  role: string;
}

export interface TermAddRequest {
  year_to: number;
  /**
   * @minimum 0
   * @nullable
   */
  order?: number | null;
  /** @nullable */
  members?: TermMemberData[] | null;
  /** @nullable */
  leadership?: TermMemberLeadershipData[] | null;
  year_from: number;
  /** @nullable */
  coalition?: number[] | null;
}

export interface TermOrderResponse {
  /** Order of the term */
  order: number;
}

export interface BaseMembership {
  /**
   * Date when this membership stopped being valid
   * @nullable
   */
  date_to: string | null;
  /** ID of the membership */
  id: number;
  /**
   * Date when this membership came into effect
   * @nullable
   */
  date_from: string | null;
  /** Political entity this membership is associated with */
  political_entity: BasePoliticalEntity;
}

export interface TermLeadership {
  /**
   * Date when the member stopped performing this role
   * @nullable
   */
  date_to: string | null;
  /** Name of the held position */
  role: string;
  /**
   * Date when the member began to perform this role
   * @nullable
   */
  date_from: string | null;
  /** Whether the member was a leader of the term */
  leader: boolean;
}

export interface TermMember {
  /** Member's order in their political entity */
  order: number;
  /** All of the member's memberships during the term */
  memberships: BaseMembership[];
  /** Member's last name */
  last_name: string;
  /** Member's first name */
  first_name: string;
  /**
   * Member's sex
   * @nullable
   */
  sex: boolean | null;
  /** ID of the political entity the member is a part of */
  political_entity_id?: number;
  /** Member's date of birth */
  birth_date?: string;
  /** All of the member's roles in the municipality leadership during the term */
  leadership_roles?: TermLeadership[];
  /** ID of the member */
  id: number;
  /** Member's aliases */
  aliases?: MemberAlias[];
}

export interface TermOneResponse {
  /** Order of the term */
  order: number;
  /** Ending year of the term */
  year_to: number;
  /** All members active during the term */
  members: TermMember[];
  /** Dataset completness status */
  dataset_complete: boolean;
  /** Starting year of the term */
  year_from: number;
  /** List of IDs of political subjects in the coalition */
  coalition: number[];
}

export interface TermEditRequest {
  year_to: number;
  /** @nullable */
  leadership?: TermMemberLeadershipData[] | null;
  dataset_complete: boolean;
  year_from: number;
  /** @nullable */
  coalition?: number[] | null;
}

export interface MeetingListResponse {
  /**
   * Date when this meeting ended (null for one-day meetings)
   * @nullable
   */
  date_to: string | null;
  /** Number of the meeting (may contain letters, too) */
  number: string;
  /** Percentual attendance at the meeting */
  attendance: number;
  /** ID of the member */
  id: number;
  /** Date when this meeting started */
  date_from: string;
}

export type MeetingMemberDataAttendance = typeof MeetingMemberDataAttendance[keyof typeof MeetingMemberDataAttendance];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingMemberDataAttendance = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface MeetingMemberData {
  id: number;
  attendance: MeetingMemberDataAttendance;
  political_entity: number;
}

export interface MeetingAddRequest {
  /** @nullable */
  date_to?: string | null;
  /** @maxLength 20 */
  number: string;
  members: MeetingMemberData[];
  /**
   * @maxLength 500
   * @nullable
   */
  recording_url?: string | null;
  /** @nullable */
  members_remove?: number[] | null;
  /** @nullable */
  members_add?: MeetingMemberData[] | null;
  date_from: string;
  force?: boolean;
}

export interface MeetingOverlapResponse {
  /** List of meetings that overlap with a given meeting */
  overlaps: MeetingListResponse[];
}

export interface MeetingMember {
  /** Member's order in their political entity */
  order: number;
  /** Member's last name */
  last_name: string;
  /** Member's first name */
  first_name: string;
  /** Percentual attendance of the member across all meetings */
  attendance: number;
  /**
   * Member's sex
   * @nullable
   */
  sex: boolean | null;
  /** ID of the member */
  id: number;
  /** Member's political entity */
  political_entity: BasePoliticalEntity;
}

export interface MeetingOneResponse {
  /**
   * Date when this meeting ended (null for one-day meetings)
   * @nullable
   */
  date_to: string | null;
  /** Number of the meeting (may contain letters, too) */
  number: string;
  /** Percentual attendance at the meeting */
  attendance: number;
  /** Active meeting members */
  members: MeetingMember[];
  /** Available members */
  available_members?: BaseMember[];
  /**
   * URL to the recording of the meeting
   * @nullable
   */
  recording_url: string | null;
  /** ID of the member */
  id: number;
  /** Date when this meeting started */
  date_from: string;
}

export interface MeetingEditRequest {
  /** @nullable */
  date_to?: string | null;
  /** @maxLength 20 */
  number: string;
  /**
   * @maxLength 500
   * @nullable
   */
  recording_url?: string | null;
  date_from: string;
  force?: boolean;
}

export interface MeetingMembersAdd {
  members: MeetingMemberData[];
}

export interface MembershipPoliticalEntityRequest {
  political_entity_id: number;
}

export type MeetingMemberAttendanceRequestAttendance = typeof MeetingMemberAttendanceRequestAttendance[keyof typeof MeetingMemberAttendanceRequestAttendance];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingMemberAttendanceRequestAttendance = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface MeetingMemberAttendanceRequest {
  attendance: MeetingMemberAttendanceRequestAttendance;
}

export interface VoteListResponse {
  /** Edit status of the vote */
  edited: boolean;
  /** Procedurality status of the vote */
  procedural: boolean;
  /** Number of the vote (may contain letters, too) */
  number: string;
  /**
   * Time of the vote in ISO format
   * @nullable
   */
  time: string | null;
  /**
   * Subject of the vote
   * @nullable
   */
  item: string | null;
  /** ID of the result of the vote */
  result: number;
  /** ID of the vote */
  id: number;
  /** Secrecy status of the vote */
  secret: boolean;
  /** Validity status of the vote */
  valid: boolean;
}

export type MemberVoteDataOption = typeof MemberVoteDataOption[keyof typeof MemberVoteDataOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MemberVoteDataOption = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
} as const;

export interface MemberVoteData {
  member_id: number;
  option: MemberVoteDataOption;
  in_person: boolean;
}

export type VoteRequestResult = typeof VoteRequestResult[keyof typeof VoteRequestResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoteRequestResult = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export interface VoteRequest {
  /**
   * @maxLength 150
   * @nullable
   */
  minutes_url?: string | null;
  /**
   * @minimum 0
   * @nullable
   */
  sum_no?: number | null;
  procedural: boolean;
  /**
   * @minimum 0
   * @nullable
   */
  sum_yes?: number | null;
  /** @maxLength 50 */
  number: string;
  /**
   * @minimum 0
   * @nullable
   */
  sum_did_not_vote?: number | null;
  /** @nullable */
  time?: string | null;
  member_votes: MemberVoteData[];
  /**
   * @minimum 0
   * @nullable
   */
  sum_absent?: number | null;
  /**
   * @maxLength 5000
   * @nullable
   */
  item?: string | null;
  /**
   * @minimum 0
   * @nullable
   */
  sum_abstained?: number | null;
  result: VoteRequestResult;
  /**
   * @minimum 0
   * @nullable
   */
  sum_excused?: number | null;
  secret: boolean;
  valid: boolean;
}

export interface EditHistoryField {
  /** New value of the field (any data type) */
  new: unknown;
  /** Original value of the field (any data type) */
  original: unknown;
  /** Name of the database field */
  field: string;
}

export interface EditHistoryItem {
  /** List of changes made with the edit */
  changes: EditHistoryField[];
  /** Login of the user who made the edit */
  edited_by: string;
  /** Date and time of this edit (formatted as %d.%m.%Y %H:%M:%S) */
  edit_date: string;
}

export interface ResponsesVoteMember {
  /** Member's order in their political entity */
  order: number;
  /** Member's last name */
  last_name: string;
  /** Member's first name */
  first_name: string;
  /**
   * Member's sex
   * @nullable
   */
  sex: boolean | null;
  /** ID of the member */
  id: number;
  /** Member's political entity */
  political_entity: BasePoliticalEntity;
}

export interface ResponsesMemberVote {
  /** List of past edits of the member vote */
  edit_history?: EditHistoryItem[];
  /** ID of the selected voting option */
  option: number;
  /** Whether the member voted in person */
  in_person: boolean;
}

/**
 * Dictionary of member votes cast during the vote (indexed by member IDs)
 */
export type VoteOneResponseMemberVotes = {[key: string]: ResponsesMemberVote};

export interface VoteOneResponse {
  /**
   * URL address to the minutes of the voting
   * @nullable
   */
  minutes_url: string | null;
  /** Sum of members who voted for no */
  sum_no: number;
  /** Procedurality status of the vote */
  procedural: boolean;
  /** Sum of members who voted for yes */
  sum_yes: number;
  /** Sum of members who were excused */
  sum_excused: number;
  /** Number of the vote (may contain letters, too) */
  number: string;
  /** Sum of members who did not vote */
  sum_did_not_vote: number;
  /**
   * Time of the vote in ISO format
   * @nullable
   */
  time: string | null;
  /** List of the vote's past edits */
  edit_history?: EditHistoryItem[];
  /** List of members active during the vote */
  members: ResponsesVoteMember[];
  /** Sum of members who were absent */
  sum_absent: number;
  /** Dictionary of member votes cast during the vote (indexed by member IDs) */
  member_votes: VoteOneResponseMemberVotes;
  /**
   * Subject of the vote
   * @nullable
   */
  item: string | null;
  /** Sum of members who abstained from voting */
  sum_abstained: number;
  /** ID of the result of the vote */
  result: number;
  /** ID of the vote */
  id: number;
  /** Secrecy status of the vote */
  secret: boolean;
  /** Validity status of the vote */
  valid: boolean;
}

export interface EnumeratorCodeResponse {
  /** ID of the option */
  id: number;
  /** Code of the option */
  code: string;
}

export interface EnumeratorResponse {
  /** Name of the option */
  name: string;
  /** ID of the option */
  id: number;
}

export interface LanguageResponse {
  /** Language name in English */
  en_name: string;
  /** Whether the language is active */
  active: boolean;
  /** Language code (e.g. "en" for English) */
  language_code: string;
  /** Language name in the local language itself */
  local_name: string;
}

export interface LanguageAddRequest {
  /** @maxLength 255 */
  en_name: string;
  active: boolean;
  /** @maxLength 10 */
  language_code: string;
  /** @maxLength 255 */
  local_name: string;
}

export interface LanguageEditRequest {
  /** @maxLength 255 */
  en_name: string;
  active: boolean;
  /** @maxLength 255 */
  local_name: string;
}

export interface DocumentTypeI18nResponse {
  /** Text of the document type option */
  document_type_text: string;
  /** ID of the document type option */
  option_id: number;
  /** Code of the document type option */
  code: string;
}

export interface VoteOptionI18nResponse {
  /** ID of the voting option */
  option_id: number;
  /** Code of the voting option */
  code: string;
  /**
   * Text for the voting option (male)
   * @nullable
   */
  male_text?: string | null;
  /**
   * Text for the voting option (female)
   * @nullable
   */
  female_text: string | null;
  /** Universal text for the voting option */
  universal_text: string;
}

export interface AttendanceI18nResponse {
  /** ID of the attendance option */
  option_id: number;
  /** Text of the attendance option */
  attendance_text: string;
  /** Code of the attendance option */
  code: string;
}

export interface MunicipalityTypeI18nResponse {
  /** Text of the municipality type option */
  typ_municipality_text: string;
  /** Genitive text of the municipality type option */
  typ_municipality_text_genitiv?: string;
  /** ID of the municipality type option */
  option_id: number;
  /** Code of the municipality type option */
  code: string;
}

export interface BodyTypeI18nResponse {
  /** Genitive text of the body type option */
  typ_organu_text_genitiv?: string;
  /** ID of the body type option */
  option_id: number;
  /** Text of the body type option */
  typ_organu_text: string;
  /** Code of the body type option */
  code: string;
}

export interface VoteResultI18nResponse {
  /** Text of the vote result option */
  vote_result_text: string;
  /** ID of the vote result option */
  option_id: number;
  /** Code of the vote result option */
  code: string;
}

export interface LanguageTranslationsResponse {
  document_types: DocumentTypeI18nResponse[];
  vote_options: VoteOptionI18nResponse[];
  attendances: AttendanceI18nResponse[];
  municipality_types: MunicipalityTypeI18nResponse[];
  body_types: BodyTypeI18nResponse[];
  vote_results: VoteResultI18nResponse[];
}

export interface DocumentTypeI18nData {
  /** @maxLength 100 */
  document_type_text: string;
  option_id: number;
}

export interface VoteOptionI18nData {
  /**
   * @maxLength 100
   * @nullable
   */
  universal_text?: string | null;
  option_id: number;
  /**
   * @maxLength 100
   * @nullable
   */
  female_text?: string | null;
  /** @maxLength 100 */
  male_text: string;
}

export interface AttendanceI18nData {
  option_id: number;
  /** @maxLength 100 */
  attendance_text: string;
}

export interface MunicipalityTypeI18nData {
  /** @maxLength 100 */
  typ_municipality_text: string;
  /**
   * @maxLength 100
   * @nullable
   */
  typ_municipality_text_genitiv?: string | null;
  option_id: number;
}

export interface BodyTypeI18nData {
  /**
   * @maxLength 100
   * @nullable
   */
  typ_organu_text_genitiv?: string | null;
  option_id: number;
  /** @maxLength 100 */
  typ_organu_text: string;
}

export interface VoteResultI18nData {
  /** @maxLength 100 */
  vote_result_text: string;
  option_id: number;
}

export interface LanguageTranslationsEditRequest {
  document_types: DocumentTypeI18nData[];
  vote_options: VoteOptionI18nData[];
  attendances: AttendanceI18nData[];
  municipality_types: MunicipalityTypeI18nData[];
  body_types: BodyTypeI18nData[];
  vote_results: VoteResultI18nData[];
}

export interface MunicipalityTranslationItemResponse {
  municipality_id: number;
  /** @nullable */
  nazev_genitiv: string | null;
  text_id: string;
  /** @nullable */
  nazev: string | null;
}

export interface MunicipalityTranslationsResponse {
  municipalities: MunicipalityTranslationItemResponse[];
}

export interface MunicipalityTranslationItemEdit {
  municipality_id: number;
  /**
   * @maxLength 150
   * @nullable
   */
  nazev_genitiv?: string | null;
  /** @maxLength 150 */
  nazev: string;
}

export interface MunicipalityTranslationsEditRequest {
  municipalities: MunicipalityTranslationItemEdit[];
}

export interface BodyTranslationItemResponse {
  organ_id: number;
  body_type_code: string;
  /** @nullable */
  nazev: string | null;
  /** @nullable */
  nazev_aplikace: string | null;
  /** @nullable */
  popis_aplikace: string | null;
  municipality_text_id: string;
  /** @nullable */
  nazev_genitiv: string | null;
}

export interface BodyTranslationsResponse {
  bodies: BodyTranslationItemResponse[];
}

export interface BodyTranslationItemEdit {
  organ_id: number;
  /** @maxLength 150 */
  nazev: string;
  /**
   * @maxLength 150
   * @nullable
   */
  nazev_aplikace?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  popis_aplikace?: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  nazev_genitiv?: string | null;
}

export interface BodyTranslationsEditRequest {
  bodies: BodyTranslationItemEdit[];
}

/**
 * Unprocessable Entity
 */
export type UnprocessableEntityResponse = Error;

export type GetSearchByMunicipalityIdAndBodyAndCouncilIdParams = {
/**
 * Optional search keyword
 */
search?: string;
};

export type GetVotesByMunicipalityIdAndBodyAndCouncilIdParams = {
/**
 * Filter by vote result ID
 */
vysledek_hlasovani?: number;
/**
 * Filter by member ID
 */
id_zastupitele?: number;
/**
 * Filter by vote option of a specific member (member ID needs to be selected)
 */
hlasovani_zastupitele?: number;
/**
 * Filter votes by description of voting
 */
popis_hlasovani?: string;
/**
 * Optional comma-separated values to filter vote types. Available options: 'secretVotes', 'invalidVotes', 'proceduralVotes'. Example: show=secretVotes,invalidVotes
 */
zobrazit?: string;
/**
 * Return votes with matching results (e.g. shoda)
 */
pohled?: string;
/**
 * Filter by meeting ID
 */
cislo_zasedani?: number;
};

export type GetAttendanceDashboardByMunicipalityIdAndBodyAndCouncilIdParams = {
/**
 * Return votes with matching results
 */
pohled?: string;
};

export type GetCompareByMunicipalityIdAndBodyAndCouncilIdParams = {
/**
 * ID of the second member to compare
 */
druhy_clen: number;
/**
 * ID of the first member to compare
 */
prvni_clen: number;
};

export type GetMetricsByScopeParams = {
geo: string;
};

export type GetFiltersByScopeParams = {
metric: string;
geo: string;
};

export type GetDataByScopeParams = {
/**
 * @nullable
 */
year_to?: number | null;
metric: string;
compare_geo?: string[];
source: string;
unit: string;
geo: string;
/**
 * @nullable
 */
year_from?: number | null;
};

export type GetRevisionsByScopeParams = {
metric: string;
geo: string;
source: string;
unit: string;
};

export type GetAdminMeetingByMunicipalityIdAndBodyParams = {
/**
 * @nullable
 */
term_id?: number | null;
/**
 * @nullable
 */
date?: string | null;
};

export type GetAdminNextByMunicipalityIdAndBodyAndTermIdParams = {
/**
 * @nullable
 */
date_from?: string | null;
};

export type GetAdminMeetingByMunicipalityIdAndBodyAndMeetingIdParams = {
/**
 * @nullable
 */
include_available?: boolean | null;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getApiClient = () => {
const getDatasetByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<Dataset>>,) => {
      return customInstance<Dataset>(
      {url: `/${municipalityId}/${body}/${councilId}/dataset`, method: 'GET'
    },
      options);
    }
  
const getSearchByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
    params?: GetSearchByMunicipalityIdAndBodyAndCouncilIdParams,
 options?: SecondParameter<typeof customInstance<SearchResult>>,) => {
      return customInstance<SearchResult>(
      {url: `/${municipalityId}/${body}/${councilId}/search`, method: 'GET',
        params
    },
      options);
    }
  
const getGeneralDataByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<GeneralData>>,) => {
      return customInstance<GeneralData>(
      {url: `/${municipalityId}/${body}/${councilId}/generalData`, method: 'GET'
    },
      options);
    }
  
const getMemberByMunicipalityIdAndBodyAndCouncilIdAndMemberId = (
    municipalityId: string,
    body: string,
    councilId: number,
    memberId: number,
 options?: SecondParameter<typeof customInstance<CouncilMember>>,) => {
      return customInstance<CouncilMember>(
      {url: `/${municipalityId}/${body}/${councilId}/member/${memberId}`, method: 'GET'
    },
      options);
    }
  
const getComparisonByMunicipalityIdAndBodyAndCouncilIdAndMemberId = (
    municipalityId: string,
    body: string,
    councilId: number,
    memberId: number,
 options?: SecondParameter<typeof customInstance<MemberComparison>>,) => {
      return customInstance<MemberComparison>(
      {url: `/${municipalityId}/${body}/${councilId}/member/${memberId}/comparison`, method: 'GET'
    },
      options);
    }
  
const getHello = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/hello`, method: 'GET'
    },
      options);
    }
  
const getAppInfo = (
    
 options?: SecondParameter<typeof customInstance<AppInfo>>,) => {
      return customInstance<AppInfo>(
      {url: `/appInfo`, method: 'GET'
    },
      options);
    }
  
const getMunicipalities = (
    
 options?: SecondParameter<typeof customInstance<Municipalities[]>>,) => {
      return customInstance<Municipalities[]>(
      {url: `/municipalities`, method: 'GET'
    },
      options);
    }
  
const getMunicipalityByMunicipalityId = (
    municipalityId: string,
 options?: SecondParameter<typeof customInstance<MunicipalityExtended>>,) => {
      return customInstance<MunicipalityExtended>(
      {url: `/municipality/${municipalityId}`, method: 'GET'
    },
      options);
    }
  
const getLogoByMunicipalityId = (
    municipalityId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/municipality/${municipalityId}/logo`, method: 'GET'
    },
      options);
    }
  
const getDetailedByMunicipalityId = (
    municipalityId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/municipality/${municipalityId}/detailed`, method: 'GET'
    },
      options);
    }
  
const getCouncilsByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<Councils[]>>,) => {
      return customInstance<Councils[]>(
      {url: `/${municipalityId}/${body}/councils`, method: 'GET'
    },
      options);
    }
  
const getSessionsDataByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<SessionData[]>>,) => {
      return customInstance<SessionData[]>(
      {url: `/${municipalityId}/${body}/${councilId}/sessionsData`, method: 'GET'
    },
      options);
    }
  
const getSessionByMunicipalityIdAndBodyAndCouncilIdAndSessionId = (
    municipalityId: string,
    body: string,
    councilId: number,
    sessionId: number,
 options?: SecondParameter<typeof customInstance<ResponsesSession>>,) => {
      return customInstance<ResponsesSession>(
      {url: `/${municipalityId}/${body}/${councilId}/session/${sessionId}`, method: 'GET'
    },
      options);
    }
  
const getSessionAttendanceByMunicipalityIdAndBodyAndCouncilIdAndSessionId = (
    municipalityId: string,
    body: string,
    councilId: number,
    sessionId: number,
 options?: SecondParameter<typeof customInstance<SessionAttendance>>,) => {
      return customInstance<SessionAttendance>(
      {url: `/${municipalityId}/${body}/${councilId}/sessionAttendance/${sessionId}`, method: 'GET'
    },
      options);
    }
  
const getVoteByMunicipalityIdAndBodyAndCouncilIdAndVoteId = (
    municipalityId: string,
    body: string,
    councilId: number,
    voteId: number,
 options?: SecondParameter<typeof customInstance<VoteDetail>>,) => {
      return customInstance<VoteDetail>(
      {url: `/${municipalityId}/${body}/${councilId}/vote/${voteId}`, method: 'GET'
    },
      options);
    }
  
const getVotesDataByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<VoteBasicData>>,) => {
      return customInstance<VoteBasicData>(
      {url: `/${municipalityId}/${body}/${councilId}/votesData`, method: 'GET'
    },
      options);
    }
  
const getVotesByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
    params?: GetVotesByMunicipalityIdAndBodyAndCouncilIdParams,
 options?: SecondParameter<typeof customInstance<VotesQuery[]>>,) => {
      return customInstance<VotesQuery[]>(
      {url: `/${municipalityId}/${body}/${councilId}/votes`, method: 'GET',
        params
    },
      options);
    }
  
const getPartiesDataByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<PartiesData[]>>,) => {
      return customInstance<PartiesData[]>(
      {url: `/${municipalityId}/${body}/${councilId}/partiesData`, method: 'GET'
    },
      options);
    }
  
const getLegalPartiesDataByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<PartiesData[]>>,) => {
      return customInstance<PartiesData[]>(
      {url: `/${municipalityId}/${body}/${councilId}/legalPartiesData`, method: 'GET'
    },
      options);
    }
  
const getPartiesStatsByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<PartyStats[]>>,) => {
      return customInstance<PartyStats[]>(
      {url: `/${municipalityId}/${body}/${councilId}/partiesStats`, method: 'GET'
    },
      options);
    }
  
const getPartyByMunicipalityIdAndBodyAndCouncilIdAndPartyId = (
    municipalityId: string,
    body: string,
    councilId: number,
    partyId: number,
 options?: SecondParameter<typeof customInstance<PartyData>>,) => {
      return customInstance<PartyData>(
      {url: `/${municipalityId}/${body}/${councilId}/party/${partyId}`, method: 'GET'
    },
      options);
    }
  
const getAgreementByMunicipalityIdAndBodyAndCouncilIdAndPartyId = (
    municipalityId: string,
    body: string,
    councilId: number,
    partyId: number,
 options?: SecondParameter<typeof customInstance<PartyAgreementItem[]>>,) => {
      return customInstance<PartyAgreementItem[]>(
      {url: `/${municipalityId}/${body}/${councilId}/party/${partyId}/agreement`, method: 'GET'
    },
      options);
    }
  
const getDropdownMemberOptionsByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<DropdownOptions[]>>,) => {
      return customInstance<DropdownOptions[]>(
      {url: `/FE/${municipalityId}/${body}/${councilId}/dropdownMemberOptions`, method: 'GET'
    },
      options);
    }
  
const getDropdownSubjectOptionsByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<DropdownOptions[]>>,) => {
      return customInstance<DropdownOptions[]>(
      {url: `/FE/${municipalityId}/${body}/${councilId}/dropdownSubjectOptions`, method: 'GET'
    },
      options);
    }
  
const getDropdownSessionOptionsByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<DropdownOptions[]>>,) => {
      return customInstance<DropdownOptions[]>(
      {url: `/FE/${municipalityId}/${body}/${councilId}/dropdownSessionOptions`, method: 'GET'
    },
      options);
    }
  
const getDropdownVoteOptionsByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<DropdownOptionsCode[]>>,) => {
      return customInstance<DropdownOptionsCode[]>(
      {url: `/FE/${municipalityId}/${body}/dropdownVoteOptions`, method: 'GET'
    },
      options);
    }
  
const getDropdownOtherVoteOptionsByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
 options?: SecondParameter<typeof customInstance<DropdownOptionsCode[]>>,) => {
      return customInstance<DropdownOptionsCode[]>(
      {url: `/FE/${municipalityId}/${body}/dropdownOtherVoteOptions/${memberId}`, method: 'GET'
    },
      options);
    }
  
const getDropdownYearOptionsByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<DropdownYearOptions[]>>,) => {
      return customInstance<DropdownYearOptions[]>(
      {url: `/FE/${municipalityId}/${body}/${councilId}/dropdownYearOptions`, method: 'GET'
    },
      options);
    }
  
const getDropdownSessionResultsByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<DropdownOptionsCode[]>>,) => {
      return customInstance<DropdownOptionsCode[]>(
      {url: `/FE/${municipalityId}/${body}/dropdownSessionResults`, method: 'GET'
    },
      options);
    }
  
const getPartiesUnityByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
 options?: SecondParameter<typeof customInstance<PartiesUnity>>,) => {
      return customInstance<PartiesUnity>(
      {url: `/${municipalityId}/${body}/${councilId}/PartiesUnity`, method: 'GET'
    },
      options);
    }
  
const getAttendanceDashboardByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
    params?: GetAttendanceDashboardByMunicipalityIdAndBodyAndCouncilIdParams,
 options?: SecondParameter<typeof customInstance<AttendanceOverview>>,) => {
      return customInstance<AttendanceOverview>(
      {url: `/${municipalityId}/${body}/${councilId}/attendanceDashboard`, method: 'GET',
        params
    },
      options);
    }
  
const getCompareByMunicipalityIdAndBodyAndCouncilId = (
    municipalityId: string,
    body: string,
    councilId: number,
    params: GetCompareByMunicipalityIdAndBodyAndCouncilIdParams,
 options?: SecondParameter<typeof customInstance<CompareResponse>>,) => {
      return customInstance<CompareResponse>(
      {url: `/${municipalityId}/${body}/${councilId}/compare`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Zoznam všetkých scope/regionov (national, regional...)
 */
const getRegions = (
    
 options?: SecondParameter<typeof customInstance<RegionsResponse>>,) => {
      return customInstance<RegionsResponse>(
      {url: `/stats/regions`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Všetky geo územia v danom scope vo forme [{id, name}, ...]
 */
const getGeoByScope = (
    scope: string,
 options?: SecondParameter<typeof customInstance<GeoResponse>>,) => {
      return customInstance<GeoResponse>(
      {url: `/stats/${scope}/geo`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Metriky pre dané geo — vracia id, name, descp, unit_labels
 */
const getMetricsByScope = (
    scope: string,
    params: GetMetricsByScopeParams,
 options?: SecondParameter<typeof customInstance<MetricsResponse>>,) => {
      return customInstance<MetricsResponse>(
      {url: `/stats/${scope}/metrics`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Filtre pre danú metriku: sources, dims, range, periods
 */
const getFiltersByScope = (
    scope: string,
    params: GetFiltersByScopeParams,
 options?: SecondParameter<typeof customInstance<FiltersResponse>>,) => {
      return customInstance<FiltersResponse>(
      {url: `/stats/${scope}/filters`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Dáta pre geo (+ compare_geo) podľa všetkých aktívnych filtrov.
 */
const getDataByScope = (
    scope: string,
    params: GetDataByScopeParams,
 options?: SecondParameter<typeof customInstance<DataResponse>>,) => {
      return customInstance<DataResponse>(
      {url: `/stats/${scope}/data`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Revízna história dát pre dané geo a filtre.
 */
const getRevisionsByScope = (
    scope: string,
    params: GetRevisionsByScopeParams,
 options?: SecondParameter<typeof customInstance<RevisionsResponse>>,) => {
      return customInstance<RevisionsResponse>(
      {url: `/stats/${scope}/revisions`, method: 'GET',
        params
    },
      options);
    }
  
const getLanguages = (
    
 options?: SecondParameter<typeof customInstance<Language[]>>,) => {
      return customInstance<Language[]>(
      {url: `/languages`, method: 'GET'
    },
      options);
    }
  
const getLangOptions = (
    
 options?: SecondParameter<typeof customInstance<DropdownLanguage[]>>,) => {
      return customInstance<DropdownLanguage[]>(
      {url: `/languages/lang-options`, method: 'GET'
    },
      options);
    }
  
const getVoteOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<VoteOptionLabelMapItem>>,) => {
      return customInstance<VoteOptionLabelMapItem>(
      {url: `/languages/${lang}/vote-options-language`, method: 'GET'
    },
      options);
    }
  
const getVoteResultOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelMap>>,) => {
      return customInstance<OptionLabelMap>(
      {url: `/languages/${lang}/vote_result-options-language`, method: 'GET'
    },
      options);
    }
  
const getAttendanceOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelMap>>,) => {
      return customInstance<OptionLabelMap>(
      {url: `/languages/${lang}/attendance-options-language`, method: 'GET'
    },
      options);
    }
  
const getAttendanceOptionsLanguageListByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelList[]>>,) => {
      return customInstance<OptionLabelList[]>(
      {url: `/languages/${lang}/attendance-options-language-list`, method: 'GET'
    },
      options);
    }
  
const getTypOrganuOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelMapItem>>,) => {
      return customInstance<OptionLabelMapItem>(
      {url: `/languages/${lang}/typ_organu-options-language`, method: 'GET'
    },
      options);
    }
  
const getTypMunicipalityOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelMapItem>>,) => {
      return customInstance<OptionLabelMapItem>(
      {url: `/languages/${lang}/typ_municipality-options-language`, method: 'GET'
    },
      options);
    }
  
const getMunicipalityNameOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OptionLabelMapItem>>,) => {
      return customInstance<OptionLabelMapItem>(
      {url: `/languages/${lang}/municipality-name-options-language`, method: 'GET'
    },
      options);
    }
  
const getOrganNameOptionsLanguageByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<OrganOptionLabelMapItem>>,) => {
      return customInstance<OrganOptionLabelMapItem>(
      {url: `/languages/${lang}/organ-name-options-language`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Vracia celý geo_descp slovník — FE si ho cashuje pri štarte.
 */
const getGeoLabelsByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<GeoLabelResponse>>,) => {
      return customInstance<GeoLabelResponse>(
      {url: `/languages/${lang}/geo_labels`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Vracia celý geo_descp slovník — FE si ho cashuje pri štarte.
 */
const getStatsLabelsByLang = (
    lang: string,
 options?: SecondParameter<typeof customInstance<StatsLabelsResponse>>,) => {
      return customInstance<StatsLabelsResponse>(
      {url: `/languages/${lang}/stats_labels`, method: 'GET'
    },
      options);
    }
  
const getAuthHello = (
    
 options?: SecondParameter<typeof customInstance<AuthHelloResponse>>,) => {
      return customInstance<AuthHelloResponse>(
      {url: `/auth-hello`, method: 'GET'
    },
      options);
    }
  
const postLogin = (
    loginRequest: BodyType<LoginRequest>,
 options?: SecondParameter<typeof customInstance<TokenResponse>>,) => {
      return customInstance<TokenResponse>(
      {url: `/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest
    },
      options);
    }
  
const postRefresh = (
    
 options?: SecondParameter<typeof customInstance<TokenResponse>>,) => {
      return customInstance<TokenResponse>(
      {url: `/refresh`, method: 'POST'
    },
      options);
    }
  
const postRegister = (
    registerRequest: BodyType<RegisterRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerRequest
    },
      options);
    }
  
const getAdminUser = (
    
 options?: SecondParameter<typeof customInstance<UserResponse[]>>,) => {
      return customInstance<UserResponse[]>(
      {url: `/admin/user`, method: 'GET'
    },
      options);
    }
  
const getAdminUserPermissions = (
    
 options?: SecondParameter<typeof customInstance<UserPermissionsResponse>>,) => {
      return customInstance<UserPermissionsResponse>(
      {url: `/admin/user-permissions`, method: 'GET'
    },
      options);
    }
  
const getAdminProfile = (
    
 options?: SecondParameter<typeof customInstance<UserResponse>>,) => {
      return customInstance<UserResponse>(
      {url: `/admin/profile`, method: 'GET'
    },
      options);
    }
  
const patchAdminName = (
    profileNameEditRequest: BodyType<ProfileNameEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/profile/name`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: profileNameEditRequest
    },
      options);
    }
  
const patchAdminPassword = (
    profileChangePasswordRequest: BodyType<ProfileChangePasswordRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/profile/password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: profileChangePasswordRequest
    },
      options);
    }
  
const getAdminManageMunicipality = (
    
 options?: SecondParameter<typeof customInstance<RequestManageMunicipalityListResponse[]>>,) => {
      return customInstance<RequestManageMunicipalityListResponse[]>(
      {url: `/admin/request/manage-municipality`, method: 'GET'
    },
      options);
    }
  
const postAdminManageMunicipality = (
    requestManageMunicipalityRequest: BodyType<RequestManageMunicipalityRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/request/manage-municipality`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestManageMunicipalityRequest
    },
      options);
    }
  
const patchAdminManageMunicipalityByRequestId = (
    requestId: number,
    requestManageMunicipalityResolveRequest: BodyType<RequestManageMunicipalityResolveRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/request/manage-municipality/${requestId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: requestManageMunicipalityResolveRequest
    },
      options);
    }
  
const getAdminAddMunicipality = (
    
 options?: SecondParameter<typeof customInstance<RequestAddMunicipalityListResponse[]>>,) => {
      return customInstance<RequestAddMunicipalityListResponse[]>(
      {url: `/admin/request/add-municipality`, method: 'GET'
    },
      options);
    }
  
const postAdminAddMunicipality = (
    requestAddMunicipalityRequest: BodyType<RequestAddMunicipalityRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/request/add-municipality`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAddMunicipalityRequest
    },
      options);
    }
  
const getAdminAddMunicipalityByRequestId = (
    requestId: number,
 options?: SecondParameter<typeof customInstance<RequestAddMunicipalityResponse>>,) => {
      return customInstance<RequestAddMunicipalityResponse>(
      {url: `/admin/request/add-municipality/${requestId}`, method: 'GET'
    },
      options);
    }
  
const patchAdminAddMunicipalityByRequestId = (
    requestId: number,
    requestAddMunicipalityResolveRequest: BodyType<RequestAddMunicipalityResolveRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/request/add-municipality/${requestId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: requestAddMunicipalityResolveRequest
    },
      options);
    }
  
const getAdminDatabase = (
    
 options?: SecondParameter<typeof customInstance<DatabaseResponse[]>>,) => {
      return customInstance<DatabaseResponse[]>(
      {url: `/admin/database`, method: 'GET'
    },
      options);
    }
  
const postAdminDatabase = (
    databaseAddRequest: BodyType<DatabaseAddRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/database`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databaseAddRequest
    },
      options);
    }
  
const getAdminDatabaseByDatabaseId = (
    databaseId: number,
 options?: SecondParameter<typeof customInstance<DatabaseResponse>>,) => {
      return customInstance<DatabaseResponse>(
      {url: `/admin/database/${databaseId}`, method: 'GET'
    },
      options);
    }
  
const putAdminDatabaseByDatabaseId = (
    databaseId: number,
    databaseEditRequest: BodyType<DatabaseEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: databaseEditRequest
    },
      options);
    }
  
const deleteAdminDatabaseByDatabaseId = (
    databaseId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}`, method: 'DELETE'
    },
      options);
    }
  
const postAdminExport = (
    databaseExportRequest: BodyType<DatabaseExportRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databaseExportRequest
    },
      options);
    }
  
const postAdminExportByDatabaseId = (
    databaseId: number,
    databaseOneExportRequest: BodyType<DatabaseOneExportRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databaseOneExportRequest
    },
      options);
    }
  
const getAdminBackupByDatabaseId = (
    databaseId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}/backup`, method: 'GET'
    },
      options);
    }
  
const postAdminBackupByDatabaseId = (
    databaseId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}/backup`, method: 'POST'
    },
      options);
    }
  
const getAdminBackupByDatabaseIdAndBackupId = (
    databaseId: number,
    backupId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/database/${databaseId}/backup/${backupId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Assumes the file is encoded in UTF-8.
TODO automatic encoding detection?
 */
const postAdminImport = (
    databaseImportRequest: BodyType<DatabaseImportRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {const formData = new FormData();
formData.append(`sql_dump`, databaseImportRequest.sql_dump)

      return customInstance<void>(
      {url: `/admin/database/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  
const getAdminMunicipality = (
    
 options?: SecondParameter<typeof customInstance<MunicipalityListResponse[]>>,) => {
      return customInstance<MunicipalityListResponse[]>(
      {url: `/admin/municipality`, method: 'GET'
    },
      options);
    }
  
const postAdminMunicipality = (
    municipalityAddRequest: BodyType<MunicipalityAddRequest>,
 options?: SecondParameter<typeof customInstance<MunicipalityTextIdResponse>>,) => {
      return customInstance<MunicipalityTextIdResponse>(
      {url: `/admin/municipality`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: municipalityAddRequest
    },
      options);
    }
  
const getAdminMunicipalityByMunicipalityId = (
    municipalityId: string,
 options?: SecondParameter<typeof customInstance<MunicipalityResponse>>,) => {
      return customInstance<MunicipalityResponse>(
      {url: `/admin/municipality/${municipalityId}`, method: 'GET'
    },
      options);
    }
  
const putAdminMunicipalityByMunicipalityId = (
    municipalityId: string,
    municipalityEditRequest: BodyType<MunicipalityEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/municipality/${municipalityId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: municipalityEditRequest
    },
      options);
    }
  
const deleteAdminMunicipalityByMunicipalityId = (
    municipalityId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/municipality/${municipalityId}`, method: 'DELETE'
    },
      options);
    }
  
const postAdminLogoByMunicipalityId = (
    municipalityId: string,
    municipalityLogoRequest: BodyType<MunicipalityLogoRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {const formData = new FormData();
formData.append(`logo`, municipalityLogoRequest.logo)

      return customInstance<void>(
      {url: `/admin/municipality/${municipalityId}/logo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  
const postAdminBodyByMunicipalityId = (
    municipalityId: string,
    bodyAddRequest: BodyType<BodyAddRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/municipality/${municipalityId}/body`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodyAddRequest
    },
      options);
    }
  
const putAdminMunicipalityByMunicipalityIdAndBodyType = (
    municipalityId: string,
    bodyType: string,
    bodyEditRequest: BodyType<BodyEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/municipality/${municipalityId}/${bodyType}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bodyEditRequest
    },
      options);
    }
  
const deleteAdminMunicipalityByMunicipalityIdAndBodyType = (
    municipalityId: string,
    bodyType: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/municipality/${municipalityId}/${bodyType}`, method: 'DELETE'
    },
      options);
    }
  
const getAdminPoliticalEntityByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<PoliticalEntityResponse[]>>,) => {
      return customInstance<PoliticalEntityResponse[]>(
      {url: `/admin/${municipalityId}/${body}/political-entity`, method: 'GET'
    },
      options);
    }
  
const postAdminPoliticalEntityByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
    politicalEntityRequest: BodyType<PoliticalEntityRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/${municipalityId}/${body}/political-entity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: politicalEntityRequest
    },
      options);
    }
  
const putAdminPoliticalEntityByMunicipalityIdAndBodyAndPoliticalEntityId = (
    municipalityId: string,
    body: string,
    politicalEntityId: number,
    politicalEntityRequest: BodyType<PoliticalEntityRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/political-entity/${politicalEntityId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: politicalEntityRequest
    },
      options);
    }
  
const postAdminDeleteByMunicipalityIdAndBodyAndPoliticalEntityId = (
    municipalityId: string,
    body: string,
    politicalEntityId: number,
    passwordRequest: BodyType<PasswordRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/political-entity/${politicalEntityId}/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordRequest
    },
      options);
    }
  
const getAdminMemberByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<MemberResponse[]>>,) => {
      return customInstance<MemberResponse[]>(
      {url: `/admin/${municipalityId}/${body}/member`, method: 'GET'
    },
      options);
    }
  
const postAdminMemberByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
    memberRequest: BodyType<MemberRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/${municipalityId}/${body}/member`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberRequest
    },
      options);
    }
  
const getAdminMeetingByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
    params?: GetAdminMeetingByMunicipalityIdAndBodyParams,
 options?: SecondParameter<typeof customInstance<MemberListMeetingResponse>>,) => {
      return customInstance<MemberListMeetingResponse>(
      {url: `/admin/${municipalityId}/${body}/member/meeting`, method: 'GET',
        params
    },
      options);
    }
  
const getAdminMemberByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
 options?: SecondParameter<typeof customInstance<MemberResponse>>,) => {
      return customInstance<MemberResponse>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}`, method: 'GET'
    },
      options);
    }
  
const putAdminMemberByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
    memberRequest: BodyType<MemberRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: memberRequest
    },
      options);
    }
  
const deleteAdminMemberByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}`, method: 'DELETE'
    },
      options);
    }
  
const getAdminAliasByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
 options?: SecondParameter<typeof customInstance<MemberAliasListResponse[]>>,) => {
      return customInstance<MemberAliasListResponse[]>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}/alias`, method: 'GET'
    },
      options);
    }
  
const postAdminAliasByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
    aliasAddRequest: BodyType<AliasAddRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}/alias`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aliasAddRequest
    },
      options);
    }
  
const deleteAdminAliasByMunicipalityIdAndBodyAndAliasId = (
    municipalityId: string,
    body: string,
    aliasId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/alias/${aliasId}`, method: 'DELETE'
    },
      options);
    }
  
const getAdminMembershipByMunicipalityIdAndBodyAndMemberId = (
    municipalityId: string,
    body: string,
    memberId: number,
 options?: SecondParameter<typeof customInstance<MembershipResponse[]>>,) => {
      return customInstance<MembershipResponse[]>(
      {url: `/admin/${municipalityId}/${body}/member/${memberId}/membership`, method: 'GET'
    },
      options);
    }
  
const postAdminOrderByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
    memberOrderRequest: BodyType<MemberOrderRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/member/order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberOrderRequest
    },
      options);
    }
  
const getAdminTermByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
 options?: SecondParameter<typeof customInstance<TermListResponse[]>>,) => {
      return customInstance<TermListResponse[]>(
      {url: `/admin/${municipalityId}/${body}/term`, method: 'GET'
    },
      options);
    }
  
const postAdminTermByMunicipalityIdAndBody = (
    municipalityId: string,
    body: string,
    termAddRequest: BodyType<TermAddRequest>,
 options?: SecondParameter<typeof customInstance<TermOrderResponse>>,) => {
      return customInstance<TermOrderResponse>(
      {url: `/admin/${municipalityId}/${body}/term`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: termAddRequest
    },
      options);
    }
  
const getAdminTermByMunicipalityIdAndBodyAndTermId = (
    municipalityId: string,
    body: string,
    termId: number,
 options?: SecondParameter<typeof customInstance<TermOneResponse>>,) => {
      return customInstance<TermOneResponse>(
      {url: `/admin/${municipalityId}/${body}/term/${termId}`, method: 'GET'
    },
      options);
    }
  
const putAdminTermByMunicipalityIdAndBodyAndTermId = (
    municipalityId: string,
    body: string,
    termId: number,
    termEditRequest: BodyType<TermEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/term/${termId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: termEditRequest
    },
      options);
    }
  
const getAdminMeetingByMunicipalityIdAndBodyAndTermId = (
    municipalityId: string,
    body: string,
    termId: number,
 options?: SecondParameter<typeof customInstance<MeetingListResponse[] | void>>,) => {
      return customInstance<MeetingListResponse[] | void>(
      {url: `/admin/${municipalityId}/${body}/term/${termId}/meeting`, method: 'GET'
    },
      options);
    }
  
const postAdminMeetingByMunicipalityIdAndBodyAndTermId = (
    municipalityId: string,
    body: string,
    termId: number,
    meetingAddRequest: BodyType<MeetingAddRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/${municipalityId}/${body}/term/${termId}/meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: meetingAddRequest
    },
      options);
    }
  
const getAdminNextByMunicipalityIdAndBodyAndTermId = (
    municipalityId: string,
    body: string,
    termId: number,
    params?: GetAdminNextByMunicipalityIdAndBodyAndTermIdParams,
 options?: SecondParameter<typeof customInstance<MeetingListResponse | void>>,) => {
      return customInstance<MeetingListResponse | void>(
      {url: `/admin/${municipalityId}/${body}/term/${termId}/meeting/next`, method: 'GET',
        params
    },
      options);
    }
  
const getAdminMeetingByMunicipalityIdAndBodyAndMeetingId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    params?: GetAdminMeetingByMunicipalityIdAndBodyAndMeetingIdParams,
 options?: SecondParameter<typeof customInstance<MeetingOneResponse>>,) => {
      return customInstance<MeetingOneResponse>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}`, method: 'GET',
        params
    },
      options);
    }
  
const putAdminMeetingByMunicipalityIdAndBodyAndMeetingId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    meetingEditRequest: BodyType<MeetingEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: meetingEditRequest
    },
      options);
    }
  
const postAdminMemberByMunicipalityIdAndBodyAndMeetingId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    meetingMembersAdd: BodyType<MeetingMembersAdd>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/member`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: meetingMembersAdd
    },
      options);
    }
  
const deleteAdminMemberByMunicipalityIdAndBodyAndMeetingIdAndMemberId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    memberId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/member/${memberId}`, method: 'DELETE'
    },
      options);
    }
  
const patchAdminPoliticalEntityByMunicipalityIdAndBodyAndMeetingIdAndMemberId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    memberId: number,
    membershipPoliticalEntityRequest: BodyType<MembershipPoliticalEntityRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/member/${memberId}/political-entity`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: membershipPoliticalEntityRequest
    },
      options);
    }
  
const patchAdminAttendanceByMunicipalityIdAndBodyAndMeetingIdAndMemberId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    memberId: number,
    meetingMemberAttendanceRequest: BodyType<MeetingMemberAttendanceRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/member/${memberId}/attendance`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: meetingMemberAttendanceRequest
    },
      options);
    }
  
const getAdminVoteByMunicipalityIdAndBodyAndMeetingId = (
    municipalityId: string,
    body: string,
    meetingId: number,
 options?: SecondParameter<typeof customInstance<VoteListResponse[]>>,) => {
      return customInstance<VoteListResponse[]>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/vote`, method: 'GET'
    },
      options);
    }
  
const postAdminVoteByMunicipalityIdAndBodyAndMeetingId = (
    municipalityId: string,
    body: string,
    meetingId: number,
    voteRequest: BodyType<VoteRequest>,
 options?: SecondParameter<typeof customInstance<IdResponse>>,) => {
      return customInstance<IdResponse>(
      {url: `/admin/${municipalityId}/${body}/meeting/${meetingId}/vote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voteRequest
    },
      options);
    }
  
const getAdminVoteByMunicipalityIdAndBodyAndVoteId = (
    municipalityId: string,
    body: string,
    voteId: number,
 options?: SecondParameter<typeof customInstance<VoteOneResponse>>,) => {
      return customInstance<VoteOneResponse>(
      {url: `/admin/${municipalityId}/${body}/vote/${voteId}`, method: 'GET'
    },
      options);
    }
  
const putAdminVoteByMunicipalityIdAndBodyAndVoteId = (
    municipalityId: string,
    body: string,
    voteId: number,
    voteRequest: BodyType<VoteRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/vote/${voteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: voteRequest
    },
      options);
    }
  
const deleteAdminVoteByMunicipalityIdAndBodyAndVoteId = (
    municipalityId: string,
    body: string,
    voteId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/${municipalityId}/${body}/vote/${voteId}`, method: 'DELETE'
    },
      options);
    }
  
const getAdminBodyType = (
    
 options?: SecondParameter<typeof customInstance<EnumeratorCodeResponse[]>>,) => {
      return customInstance<EnumeratorCodeResponse[]>(
      {url: `/admin/body-type`, method: 'GET'
    },
      options);
    }
  
const getAdminDatabaseType = (
    
 options?: SecondParameter<typeof customInstance<EnumeratorResponse[]>>,) => {
      return customInstance<EnumeratorResponse[]>(
      {url: `/admin/database-type`, method: 'GET'
    },
      options);
    }
  
const getAdminMunicipalityType = (
    
 options?: SecondParameter<typeof customInstance<EnumeratorCodeResponse[]>>,) => {
      return customInstance<EnumeratorCodeResponse[]>(
      {url: `/admin/municipality-type`, method: 'GET'
    },
      options);
    }
  
const getAdminLanguage = (
    
 options?: SecondParameter<typeof customInstance<LanguageResponse[]>>,) => {
      return customInstance<LanguageResponse[]>(
      {url: `/admin/language`, method: 'GET'
    },
      options);
    }
  
const postAdminLanguage = (
    languageAddRequest: BodyType<LanguageAddRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: languageAddRequest
    },
      options);
    }
  
const putAdminLanguageByLanguageCode = (
    languageCode: string,
    languageEditRequest: BodyType<LanguageEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language/${languageCode}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: languageEditRequest
    },
      options);
    }
  
const deleteAdminLanguageByLanguageCode = (
    languageCode: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language/${languageCode}`, method: 'DELETE'
    },
      options);
    }
  
const getAdminTranslationsByLanguageCode = (
    languageCode: string,
 options?: SecondParameter<typeof customInstance<LanguageTranslationsResponse>>,) => {
      return customInstance<LanguageTranslationsResponse>(
      {url: `/admin/language/${languageCode}/translations`, method: 'GET'
    },
      options);
    }
  
const putAdminTranslationsByLanguageCode = (
    languageCode: string,
    languageTranslationsEditRequest: BodyType<LanguageTranslationsEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language/${languageCode}/translations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: languageTranslationsEditRequest
    },
      options);
    }
  
const getAdminMunicipalityTranslationsByLanguageCode = (
    languageCode: string,
 options?: SecondParameter<typeof customInstance<MunicipalityTranslationsResponse>>,) => {
      return customInstance<MunicipalityTranslationsResponse>(
      {url: `/admin/language/${languageCode}/municipality-translations`, method: 'GET'
    },
      options);
    }
  
const putAdminMunicipalityTranslationsByLanguageCode = (
    languageCode: string,
    municipalityTranslationsEditRequest: BodyType<MunicipalityTranslationsEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language/${languageCode}/municipality-translations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: municipalityTranslationsEditRequest
    },
      options);
    }
  
const getAdminBodyTranslationsByLanguageCode = (
    languageCode: string,
 options?: SecondParameter<typeof customInstance<BodyTranslationsResponse>>,) => {
      return customInstance<BodyTranslationsResponse>(
      {url: `/admin/language/${languageCode}/body-translations`, method: 'GET'
    },
      options);
    }
  
const putAdminBodyTranslationsByLanguageCode = (
    languageCode: string,
    bodyTranslationsEditRequest: BodyType<BodyTranslationsEditRequest>,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/language/${languageCode}/body-translations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bodyTranslationsEditRequest
    },
      options);
    }
  
return {getDatasetByMunicipalityIdAndBodyAndCouncilId,getSearchByMunicipalityIdAndBodyAndCouncilId,getGeneralDataByMunicipalityIdAndBodyAndCouncilId,getMemberByMunicipalityIdAndBodyAndCouncilIdAndMemberId,getComparisonByMunicipalityIdAndBodyAndCouncilIdAndMemberId,getHello,getAppInfo,getMunicipalities,getMunicipalityByMunicipalityId,getLogoByMunicipalityId,getDetailedByMunicipalityId,getCouncilsByMunicipalityIdAndBody,getSessionsDataByMunicipalityIdAndBodyAndCouncilId,getSessionByMunicipalityIdAndBodyAndCouncilIdAndSessionId,getSessionAttendanceByMunicipalityIdAndBodyAndCouncilIdAndSessionId,getVoteByMunicipalityIdAndBodyAndCouncilIdAndVoteId,getVotesDataByMunicipalityIdAndBodyAndCouncilId,getVotesByMunicipalityIdAndBodyAndCouncilId,getPartiesDataByMunicipalityIdAndBodyAndCouncilId,getLegalPartiesDataByMunicipalityIdAndBodyAndCouncilId,getPartiesStatsByMunicipalityIdAndBodyAndCouncilId,getPartyByMunicipalityIdAndBodyAndCouncilIdAndPartyId,getAgreementByMunicipalityIdAndBodyAndCouncilIdAndPartyId,getDropdownMemberOptionsByMunicipalityIdAndBodyAndCouncilId,getDropdownSubjectOptionsByMunicipalityIdAndBodyAndCouncilId,getDropdownSessionOptionsByMunicipalityIdAndBodyAndCouncilId,getDropdownVoteOptionsByMunicipalityIdAndBody,getDropdownOtherVoteOptionsByMunicipalityIdAndBodyAndMemberId,getDropdownYearOptionsByMunicipalityIdAndBodyAndCouncilId,getDropdownSessionResultsByMunicipalityIdAndBody,getPartiesUnityByMunicipalityIdAndBodyAndCouncilId,getAttendanceDashboardByMunicipalityIdAndBodyAndCouncilId,getCompareByMunicipalityIdAndBodyAndCouncilId,getRegions,getGeoByScope,getMetricsByScope,getFiltersByScope,getDataByScope,getRevisionsByScope,getLanguages,getLangOptions,getVoteOptionsLanguageByLang,getVoteResultOptionsLanguageByLang,getAttendanceOptionsLanguageByLang,getAttendanceOptionsLanguageListByLang,getTypOrganuOptionsLanguageByLang,getTypMunicipalityOptionsLanguageByLang,getMunicipalityNameOptionsLanguageByLang,getOrganNameOptionsLanguageByLang,getGeoLabelsByLang,getStatsLabelsByLang,getAuthHello,postLogin,postRefresh,postRegister,getAdminUser,getAdminUserPermissions,getAdminProfile,patchAdminName,patchAdminPassword,getAdminManageMunicipality,postAdminManageMunicipality,patchAdminManageMunicipalityByRequestId,getAdminAddMunicipality,postAdminAddMunicipality,getAdminAddMunicipalityByRequestId,patchAdminAddMunicipalityByRequestId,getAdminDatabase,postAdminDatabase,getAdminDatabaseByDatabaseId,putAdminDatabaseByDatabaseId,deleteAdminDatabaseByDatabaseId,postAdminExport,postAdminExportByDatabaseId,getAdminBackupByDatabaseId,postAdminBackupByDatabaseId,getAdminBackupByDatabaseIdAndBackupId,postAdminImport,getAdminMunicipality,postAdminMunicipality,getAdminMunicipalityByMunicipalityId,putAdminMunicipalityByMunicipalityId,deleteAdminMunicipalityByMunicipalityId,postAdminLogoByMunicipalityId,postAdminBodyByMunicipalityId,putAdminMunicipalityByMunicipalityIdAndBodyType,deleteAdminMunicipalityByMunicipalityIdAndBodyType,getAdminPoliticalEntityByMunicipalityIdAndBody,postAdminPoliticalEntityByMunicipalityIdAndBody,putAdminPoliticalEntityByMunicipalityIdAndBodyAndPoliticalEntityId,postAdminDeleteByMunicipalityIdAndBodyAndPoliticalEntityId,getAdminMemberByMunicipalityIdAndBody,postAdminMemberByMunicipalityIdAndBody,getAdminMeetingByMunicipalityIdAndBody,getAdminMemberByMunicipalityIdAndBodyAndMemberId,putAdminMemberByMunicipalityIdAndBodyAndMemberId,deleteAdminMemberByMunicipalityIdAndBodyAndMemberId,getAdminAliasByMunicipalityIdAndBodyAndMemberId,postAdminAliasByMunicipalityIdAndBodyAndMemberId,deleteAdminAliasByMunicipalityIdAndBodyAndAliasId,getAdminMembershipByMunicipalityIdAndBodyAndMemberId,postAdminOrderByMunicipalityIdAndBody,getAdminTermByMunicipalityIdAndBody,postAdminTermByMunicipalityIdAndBody,getAdminTermByMunicipalityIdAndBodyAndTermId,putAdminTermByMunicipalityIdAndBodyAndTermId,getAdminMeetingByMunicipalityIdAndBodyAndTermId,postAdminMeetingByMunicipalityIdAndBodyAndTermId,getAdminNextByMunicipalityIdAndBodyAndTermId,getAdminMeetingByMunicipalityIdAndBodyAndMeetingId,putAdminMeetingByMunicipalityIdAndBodyAndMeetingId,postAdminMemberByMunicipalityIdAndBodyAndMeetingId,deleteAdminMemberByMunicipalityIdAndBodyAndMeetingIdAndMemberId,patchAdminPoliticalEntityByMunicipalityIdAndBodyAndMeetingIdAndMemberId,patchAdminAttendanceByMunicipalityIdAndBodyAndMeetingIdAndMemberId,getAdminVoteByMunicipalityIdAndBodyAndMeetingId,postAdminVoteByMunicipalityIdAndBodyAndMeetingId,getAdminVoteByMunicipalityIdAndBodyAndVoteId,putAdminVoteByMunicipalityIdAndBodyAndVoteId,deleteAdminVoteByMunicipalityIdAndBodyAndVoteId,getAdminBodyType,getAdminDatabaseType,getAdminMunicipalityType,getAdminLanguage,postAdminLanguage,putAdminLanguageByLanguageCode,deleteAdminLanguageByLanguageCode,getAdminTranslationsByLanguageCode,putAdminTranslationsByLanguageCode,getAdminMunicipalityTranslationsByLanguageCode,putAdminMunicipalityTranslationsByLanguageCode,getAdminBodyTranslationsByLanguageCode,putAdminBodyTranslationsByLanguageCode}};
export type GetDatasetByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDatasetByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetSearchByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getSearchByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetGeneralDataByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getGeneralDataByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetMemberByMunicipalityIdAndBodyAndCouncilIdAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getMemberByMunicipalityIdAndBodyAndCouncilIdAndMemberId']>>>
export type GetComparisonByMunicipalityIdAndBodyAndCouncilIdAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getComparisonByMunicipalityIdAndBodyAndCouncilIdAndMemberId']>>>
export type GetHelloResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getHello']>>>
export type GetAppInfoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAppInfo']>>>
export type GetMunicipalitiesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getMunicipalities']>>>
export type GetMunicipalityByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getMunicipalityByMunicipalityId']>>>
export type GetLogoByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getLogoByMunicipalityId']>>>
export type GetDetailedByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDetailedByMunicipalityId']>>>
export type GetCouncilsByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getCouncilsByMunicipalityIdAndBody']>>>
export type GetSessionsDataByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getSessionsDataByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetSessionByMunicipalityIdAndBodyAndCouncilIdAndSessionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getSessionByMunicipalityIdAndBodyAndCouncilIdAndSessionId']>>>
export type GetSessionAttendanceByMunicipalityIdAndBodyAndCouncilIdAndSessionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getSessionAttendanceByMunicipalityIdAndBodyAndCouncilIdAndSessionId']>>>
export type GetVoteByMunicipalityIdAndBodyAndCouncilIdAndVoteIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getVoteByMunicipalityIdAndBodyAndCouncilIdAndVoteId']>>>
export type GetVotesDataByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getVotesDataByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetVotesByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getVotesByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetPartiesDataByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getPartiesDataByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetLegalPartiesDataByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getLegalPartiesDataByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetPartiesStatsByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getPartiesStatsByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetPartyByMunicipalityIdAndBodyAndCouncilIdAndPartyIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getPartyByMunicipalityIdAndBodyAndCouncilIdAndPartyId']>>>
export type GetAgreementByMunicipalityIdAndBodyAndCouncilIdAndPartyIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAgreementByMunicipalityIdAndBodyAndCouncilIdAndPartyId']>>>
export type GetDropdownMemberOptionsByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownMemberOptionsByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetDropdownSubjectOptionsByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownSubjectOptionsByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetDropdownSessionOptionsByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownSessionOptionsByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetDropdownVoteOptionsByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownVoteOptionsByMunicipalityIdAndBody']>>>
export type GetDropdownOtherVoteOptionsByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownOtherVoteOptionsByMunicipalityIdAndBodyAndMemberId']>>>
export type GetDropdownYearOptionsByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownYearOptionsByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetDropdownSessionResultsByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDropdownSessionResultsByMunicipalityIdAndBody']>>>
export type GetPartiesUnityByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getPartiesUnityByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetAttendanceDashboardByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAttendanceDashboardByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetCompareByMunicipalityIdAndBodyAndCouncilIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getCompareByMunicipalityIdAndBodyAndCouncilId']>>>
export type GetRegionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getRegions']>>>
export type GetGeoByScopeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getGeoByScope']>>>
export type GetMetricsByScopeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getMetricsByScope']>>>
export type GetFiltersByScopeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getFiltersByScope']>>>
export type GetDataByScopeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getDataByScope']>>>
export type GetRevisionsByScopeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getRevisionsByScope']>>>
export type GetLanguagesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getLanguages']>>>
export type GetLangOptionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getLangOptions']>>>
export type GetVoteOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getVoteOptionsLanguageByLang']>>>
export type GetVoteResultOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getVoteResultOptionsLanguageByLang']>>>
export type GetAttendanceOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAttendanceOptionsLanguageByLang']>>>
export type GetAttendanceOptionsLanguageListByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAttendanceOptionsLanguageListByLang']>>>
export type GetTypOrganuOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getTypOrganuOptionsLanguageByLang']>>>
export type GetTypMunicipalityOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getTypMunicipalityOptionsLanguageByLang']>>>
export type GetMunicipalityNameOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getMunicipalityNameOptionsLanguageByLang']>>>
export type GetOrganNameOptionsLanguageByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getOrganNameOptionsLanguageByLang']>>>
export type GetGeoLabelsByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getGeoLabelsByLang']>>>
export type GetStatsLabelsByLangResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getStatsLabelsByLang']>>>
export type GetAuthHelloResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAuthHello']>>>
export type PostLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postLogin']>>>
export type PostRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postRefresh']>>>
export type PostRegisterResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postRegister']>>>
export type GetAdminUserResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminUser']>>>
export type GetAdminUserPermissionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminUserPermissions']>>>
export type GetAdminProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminProfile']>>>
export type PatchAdminNameResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminName']>>>
export type PatchAdminPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminPassword']>>>
export type GetAdminManageMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminManageMunicipality']>>>
export type PostAdminManageMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminManageMunicipality']>>>
export type PatchAdminManageMunicipalityByRequestIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminManageMunicipalityByRequestId']>>>
export type GetAdminAddMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminAddMunicipality']>>>
export type PostAdminAddMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminAddMunicipality']>>>
export type GetAdminAddMunicipalityByRequestIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminAddMunicipalityByRequestId']>>>
export type PatchAdminAddMunicipalityByRequestIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminAddMunicipalityByRequestId']>>>
export type GetAdminDatabaseResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminDatabase']>>>
export type PostAdminDatabaseResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminDatabase']>>>
export type GetAdminDatabaseByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminDatabaseByDatabaseId']>>>
export type PutAdminDatabaseByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminDatabaseByDatabaseId']>>>
export type DeleteAdminDatabaseByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminDatabaseByDatabaseId']>>>
export type PostAdminExportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminExport']>>>
export type PostAdminExportByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminExportByDatabaseId']>>>
export type GetAdminBackupByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminBackupByDatabaseId']>>>
export type PostAdminBackupByDatabaseIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminBackupByDatabaseId']>>>
export type GetAdminBackupByDatabaseIdAndBackupIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminBackupByDatabaseIdAndBackupId']>>>
export type PostAdminImportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminImport']>>>
export type GetAdminMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMunicipality']>>>
export type PostAdminMunicipalityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminMunicipality']>>>
export type GetAdminMunicipalityByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMunicipalityByMunicipalityId']>>>
export type PutAdminMunicipalityByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminMunicipalityByMunicipalityId']>>>
export type DeleteAdminMunicipalityByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminMunicipalityByMunicipalityId']>>>
export type PostAdminLogoByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminLogoByMunicipalityId']>>>
export type PostAdminBodyByMunicipalityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminBodyByMunicipalityId']>>>
export type PutAdminMunicipalityByMunicipalityIdAndBodyTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminMunicipalityByMunicipalityIdAndBodyType']>>>
export type DeleteAdminMunicipalityByMunicipalityIdAndBodyTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminMunicipalityByMunicipalityIdAndBodyType']>>>
export type GetAdminPoliticalEntityByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminPoliticalEntityByMunicipalityIdAndBody']>>>
export type PostAdminPoliticalEntityByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminPoliticalEntityByMunicipalityIdAndBody']>>>
export type PutAdminPoliticalEntityByMunicipalityIdAndBodyAndPoliticalEntityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminPoliticalEntityByMunicipalityIdAndBodyAndPoliticalEntityId']>>>
export type PostAdminDeleteByMunicipalityIdAndBodyAndPoliticalEntityIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminDeleteByMunicipalityIdAndBodyAndPoliticalEntityId']>>>
export type GetAdminMemberByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMemberByMunicipalityIdAndBody']>>>
export type PostAdminMemberByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminMemberByMunicipalityIdAndBody']>>>
export type GetAdminMeetingByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMeetingByMunicipalityIdAndBody']>>>
export type GetAdminMemberByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMemberByMunicipalityIdAndBodyAndMemberId']>>>
export type PutAdminMemberByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminMemberByMunicipalityIdAndBodyAndMemberId']>>>
export type DeleteAdminMemberByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminMemberByMunicipalityIdAndBodyAndMemberId']>>>
export type GetAdminAliasByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminAliasByMunicipalityIdAndBodyAndMemberId']>>>
export type PostAdminAliasByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminAliasByMunicipalityIdAndBodyAndMemberId']>>>
export type DeleteAdminAliasByMunicipalityIdAndBodyAndAliasIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminAliasByMunicipalityIdAndBodyAndAliasId']>>>
export type GetAdminMembershipByMunicipalityIdAndBodyAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMembershipByMunicipalityIdAndBodyAndMemberId']>>>
export type PostAdminOrderByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminOrderByMunicipalityIdAndBody']>>>
export type GetAdminTermByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminTermByMunicipalityIdAndBody']>>>
export type PostAdminTermByMunicipalityIdAndBodyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminTermByMunicipalityIdAndBody']>>>
export type GetAdminTermByMunicipalityIdAndBodyAndTermIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminTermByMunicipalityIdAndBodyAndTermId']>>>
export type PutAdminTermByMunicipalityIdAndBodyAndTermIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminTermByMunicipalityIdAndBodyAndTermId']>>>
export type GetAdminMeetingByMunicipalityIdAndBodyAndTermIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMeetingByMunicipalityIdAndBodyAndTermId']>>>
export type PostAdminMeetingByMunicipalityIdAndBodyAndTermIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminMeetingByMunicipalityIdAndBodyAndTermId']>>>
export type GetAdminNextByMunicipalityIdAndBodyAndTermIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminNextByMunicipalityIdAndBodyAndTermId']>>>
export type GetAdminMeetingByMunicipalityIdAndBodyAndMeetingIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMeetingByMunicipalityIdAndBodyAndMeetingId']>>>
export type PutAdminMeetingByMunicipalityIdAndBodyAndMeetingIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminMeetingByMunicipalityIdAndBodyAndMeetingId']>>>
export type PostAdminMemberByMunicipalityIdAndBodyAndMeetingIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminMemberByMunicipalityIdAndBodyAndMeetingId']>>>
export type DeleteAdminMemberByMunicipalityIdAndBodyAndMeetingIdAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminMemberByMunicipalityIdAndBodyAndMeetingIdAndMemberId']>>>
export type PatchAdminPoliticalEntityByMunicipalityIdAndBodyAndMeetingIdAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminPoliticalEntityByMunicipalityIdAndBodyAndMeetingIdAndMemberId']>>>
export type PatchAdminAttendanceByMunicipalityIdAndBodyAndMeetingIdAndMemberIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['patchAdminAttendanceByMunicipalityIdAndBodyAndMeetingIdAndMemberId']>>>
export type GetAdminVoteByMunicipalityIdAndBodyAndMeetingIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminVoteByMunicipalityIdAndBodyAndMeetingId']>>>
export type PostAdminVoteByMunicipalityIdAndBodyAndMeetingIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminVoteByMunicipalityIdAndBodyAndMeetingId']>>>
export type GetAdminVoteByMunicipalityIdAndBodyAndVoteIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminVoteByMunicipalityIdAndBodyAndVoteId']>>>
export type PutAdminVoteByMunicipalityIdAndBodyAndVoteIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminVoteByMunicipalityIdAndBodyAndVoteId']>>>
export type DeleteAdminVoteByMunicipalityIdAndBodyAndVoteIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminVoteByMunicipalityIdAndBodyAndVoteId']>>>
export type GetAdminBodyTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminBodyType']>>>
export type GetAdminDatabaseTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminDatabaseType']>>>
export type GetAdminMunicipalityTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMunicipalityType']>>>
export type GetAdminLanguageResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminLanguage']>>>
export type PostAdminLanguageResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['postAdminLanguage']>>>
export type PutAdminLanguageByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminLanguageByLanguageCode']>>>
export type DeleteAdminLanguageByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['deleteAdminLanguageByLanguageCode']>>>
export type GetAdminTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminTranslationsByLanguageCode']>>>
export type PutAdminTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminTranslationsByLanguageCode']>>>
export type GetAdminMunicipalityTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminMunicipalityTranslationsByLanguageCode']>>>
export type PutAdminMunicipalityTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminMunicipalityTranslationsByLanguageCode']>>>
export type GetAdminBodyTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['getAdminBodyTranslationsByLanguageCode']>>>
export type PutAdminBodyTranslationsByLanguageCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getApiClient>['putAdminBodyTranslationsByLanguageCode']>>>
